export const translations = {
  kannada: {
    // Header & Navbar
    nav: {
      home: 'ಮುಖಪುಟ',
      about: 'ಬಿಬಿಸಿ ಬಗ್ಗೆ',
      project: 'ಯೋಜನೆ',
      interchanges: 'PRR-1ರ 11 ಇಂಟರ್‌ಚೇಂಜ್‌ಗಳು',
      design: 'ವಿನ್ಯಾಸ ಮತ್ತು ಸುರಕ್ಷತೆ',
      mobility: 'ಸ್ಮಾರ್ಟ್ ಟೋಲಿಂಗ್ ವ್ಯವಸ್ಥೆ',
      its: 'ಇಂಟೆಲಿಜೆಂಟ್ ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ ಸಿಸ್ಟಮ್ಸ್ (ITS)',
      environment: 'ಪರಿಸರ ಕಾಳಜಿ',
      delivery: 'ವೆಚ್ಚ ಮತ್ತು ಕಾಲಮಿತಿ',
      prrProject: 'ಪಿಆರ್‌ಆರ್‌ ಅಭಿವೃದ್ಧಿ ಪಥ',
      compensation: 'ಗ್ರಾಮವಾರು ಪರಿಹಾರ',
      contact: 'ಸಂಪರ್ಕಿಸಿ'
    },
    header: {
      cmName: 'ಶ್ರೀ ಸಿದ್ದರಾಮಯ್ಯ',
      cmTitle: 'ಸನ್ಮಾನ್ಯ ಮುಖ್ಯಮಂತ್ರಿಗಳು',
      cmTitleLine2: 'ಕರ್ನಾಟಕ ಸರ್ಕಾರ',
      dcmName: 'ಶ್ರೀ ಡಿ.ಕೆ.ಶಿವಕುಮಾರ್',
      dcmTitle: 'ಸನ್ಮಾನ್ಯ ಮುಖ್ಯಮಂತ್ರಿಗಳು',
      dcmTitleLine2: 'ಕರ್ನಾಟಕ ಸರ್ಕಾರ'
    },
    
    // Hero Section
    hero: {
      badge: 'ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್',
      title: '',
      description: 'ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್‌ ಕಾರಿಡಾರ್ (BBC) ಎಂಬುದು ಕರ್ನಾಟಕ ಸರ್ಕಾರವು ಬೆಂಗಳೂರು ಅಭಿವೃದ್ಧಿ ಪ್ರಾಧಿಕಾರದ (BDA) ಅಡಿಯಲ್ಲಿ ರಚಿಸಿರುವ ವಿಶೇಷ ಉದ್ದೇಶದ ಘಟಕ(SPV) ಆಗಿದೆ. ಇದು ಪೆರಿಫೆರಲ್ ರಿಂಗ್ ರೋಡ್ (PRR) ಮತ್ತು ಸಂಬಂಧಿತ ಮೂಲಸೌಕರ್ಯ ಯೋಜನೆಗಳನ್ನು ಅನುಷ್ಠಾನಗೊಳಿಸಲು ಸ್ಥಾಪಿತವಾಗಿದೆ. ಇದನ್ನು ಈ ಹಿಂದೆ \'ಬೆಂಗಳೂರು ಪಿಆರ್‌ಆರ್ ಡೆವಲಪ್‌ಮೆಂಟ್ ಕಾರ್ಪೋರೇಶನ್ ಲಿಮಿಟೆಡ್\' ಎಂದು ಕರೆಯಲಾಗುತ್ತಿತ್ತು, 2024ರಲ್ಲಿ ಇದನ್ನು \'ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್ ಲಿಮಿಟೆಡ್\' ಎಂದು ಮರುನಾಮಕರಣ ಮಾಡಲಾಯಿತು.',
      exploreButton: 'ಯೋಜನೆಯನ್ನು ಅನ್ವೇಷಿಸಿ',
      readMore: 'ಇನ್ನಷ್ಟು ಓದಿ',
      readMoreContent: 'ತಂತ್ರಜ್ಞಾನ ಮತ್ತು ಕೈಗಾರಿಕಾ ಕೇಂದ್ರವಾಗಿ ಬೆಂಗಳೂರು ಕ್ಷಿಪ್ರಗತಿಯಲ್ಲಿ ಬೆಳವಣಿಗೆ ಹೊಂದುತ್ತಿದ್ದು, ಈಗ ಇರುವ ರಸ್ತೆ ಸಂಪರ್ಕದ ಮೇಲೆ ಹೆಚ್ಚಿನ ಒತ್ತಡವನ್ನು ಹೇರಿದೆ. ಹೊರ ವರ್ತುಲ ರಸ್ತೆ (Outer Ring Road) ಮತ್ತು ಪ್ರಮುಖ ರಸ್ತೆಗಳಲ್ಲಿ  ಸಂಚಾರ ದಟ್ಟಣೆಯಿಂದಾಗಿ ಪ್ರಯಾಣದ ಸಮಯವು ಅಧಿಕವಾಗುತ್ತಿದ್ದು, ಉತ್ಪಾದಕತೆ ಹಾಗೂ ನಗರದ ಚಲನಶೀಲತೆಯ ಮೇಲೆ ವ್ಯತಿರಿಕ್ತ ಪರಿಣಾಮ ಬೀರುತ್ತಿದೆ. ಈ ಸವಾಲನ್ನು ಎದುರಿಸಲು ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್‌ ಕಾರಿಡಾರ್‌ ಉತ್ತಮ ಪರಿಹಾರೋಪಾಯವಾಗಿದೆ.\n\nಈ ಯೋಜನೆಯು 8 ಪಥದ, ಪ್ರವೇಶ-ನಿಯಂತ್ರಿತ (access-controlled) ನಗರ ಹೆದ್ದಾರಿಯಾಗಿರಲಿದೆ. ಇದು ಸರ್ವಿಸ್ ರಸ್ತೆಗಳು, ಸ್ಮಾರ್ಟ್ ಟೋಲಿಂಗ್ ವ್ಯವಸ್ಥೆಗಳು ಮತ್ತು ಮೆಟ್ರೋ ಹಾಗೂ ಸಮೂಹ ಸಾರಿಗೆ ವ್ಯವಸ್ಥೆಯನ್ನು ಒಳಗೊಂಡಿದೆ. ದೀರ್ಘಾವಧಿಯ ಪರಿಹಾರವಾಗಿ ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ಬಿಬಿಸಿ, ಜಾಗತಿಕ ಮಟ್ಟದ ನಗರಕ್ಕೆ ತಕ್ಕದಾದ ಹೆಚ್ಚಿನ ಸಾಮರ್ಥ್ಯದ ರಸ್ತೆ ಮೂಲಸೌಕರ್ಯಗಳನ್ನು ಹೊಂದಿರಲಿದೆ.\n\nಬೆಂಗಳೂರಿನ ಎಲ್ಲಾ ಪ್ರಮುಖ ರಾಷ್ಟ್ರೀಯ ಮತ್ತು ರಾಜ್ಯ ಹೆದ್ದಾರಿಗಳನ್ನು ಸಂಪರ್ಕಿಸಲು ಈ ಮಾರ್ಗವನ್ನು ವ್ಯವಸ್ಥಿತವಾಗಿ ಯೋಜಿಸಲಾಗಿದೆ. ಇದು ಮಾದಾವರ ಬಳಿಯ ತುಮಕೂರು ರಸ್ತೆಯಲ್ಲಿ (NH-4) ಪ್ರಾರಂಭವಾಗಿ, ಉತ್ತರ ಮತ್ತು ಪೂರ್ವದ ರಸ್ತೆಗಳ ಮೂಲಕ ಹಾದು, ದಕ್ಷಿಣದ ಕೋನಪ್ಪನ ಅಗ್ರಹಾರದ ಬಳಿ ಹೊಸೂರು ರಸ್ತೆಯಲ್ಲಿ ಅಂತ್ಯಗೊಳ್ಳುತ್ತದೆ. ಇದು ನಗರಗಳ ನಡುವೆ ಮತ್ತು ನಗರದೊಳಗಿನ ಸಂಪರ್ಕವನ್ನು ಸುಗಮಗೊಳಿಸುತ್ತದೆ.'
    },

    // About Section
    about: {
      title: 'ಬಿಬಿಸಿ ಬಗ್ಗೆ',
      intro: 'ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್ (BBC) ಇದು ಬೆಂಗಳೂರು ಅಭಿವೃದ್ಧಿ ಪ್ರಾಧಿಕಾರದ (BDA) ಅಡಿಯಲ್ಲಿ ಕರ್ನಾಟಕ ಸರ್ಕಾರದಿಂದ ರಚಿಸಲಾದ ವಿಶೇಷ ಉದ್ದೇಶದ ಘಟಕವಾಗಿದೆ (SPV). ಪೆರಿಫೆರಲ್ ರಿಂಗ್ ರೋಡ್ (PRR) ಮತ್ತು ಸಂಬಂಧಿತ ಮೂಲಸೌಕರ್ಯ ಯೋಜನೆಗಳನ್ನು ಕಾರ್ಯಗತಗೊಳಿಸಲು ಇದನ್ನು ರಚಿಸಲಾಗಿದೆ. ಈ ಹಿಂದೆ ಇದನ್ನು ಬೆಂಗಳೂರು ಪಿ.ಆರ್.ಆರ್. ಡೆವಲಪ್‌ಮೆಂಟ್ ಕಾರ್ಪೊರೇಷನ್ ಲಿಮಿಟೆಡ್ ಎಂದು ಕರೆಯಲಾಗುತ್ತಿತ್ತು, ಇದನ್ನು 2024ರಲ್ಲಿ ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್ ಲಿಮಿಟೆಡ್ ಎಂದು ಮರುನಾಮಕರಣ ಮಾಡಲಾಗಿದೆ.',
      subtitle: 'ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್‌ ಕಾರಿಡಾರ್-‌ ನಗರದ ಸುತ್ತ ಪ್ರಗತಿಯ ವೃತ್ತ',
      description1: 'ಬೆಂಗಳೂರು ವೇಗವಾಗಿ ಬೆಳೆಯುತ್ತಿರುವ ನಗರ. ನಮ್ಮ ಐಟಿ ಹಬ್‌ಗಳು ಮತ್ತು ಉದ್ಯಮಗಳು ಭಾರತದ ಸಿಲಿಕಾನ್ ವ್ಯಾಲಿ ಎಂಬ ಹೆಗ್ಗಳಿಕೆಯನ್ನು ತಂದುಕೊಟ್ಟಿವೆ. ಆದರೆ ಈ ಬೆಳವಣಿಗೆಯ ಜೊತೆಗೆ ಟ್ರಾಫಿಕ್ ಸಮಸ್ಯೆ ಕೂಡ ಹೆಚ್ಚಾಗಿದೆ. ಹೊರವರ್ತುಲ ರಸ್ತೆ (ORR) ಮೇಲಿನ ಒತ್ತಡವನ್ನು ಕಡಿಮೆ ಮಾಡಲು ಮತ್ತು ಪ್ರಯಾಣವನ್ನು ಸುಗಮಗೊಳಿಸಲು ಈಗ ಸಿದ್ಧವಾಗುತ್ತಿದೆ- ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್.',
      description2: 'ಪೆರಿಫೆರಲ್ ರಿಂಗ್ ರೋಡ್ (PRR) ಈ ಯೋಜನೆಯ ಮುಖ್ಯ ಭಾಗವಾಗಿದ್ದು, ಇದು ಕೇವಲ ರಸ್ತೆಯಲ್ಲ, ಬೆಂಗಳೂರಿನ ಭವಿಷ್ಯದ ಆರ್ಥಿಕ ಶಕ್ತಿಯನ್ನು ವರ್ಧಿಸಲಿದೆ. 8 ಪಥಗಳ ಈ ಹೆದ್ದಾರಿ, ಮೆಟ್ರೋ ವ್ಯವಸ್ಥೆ ಮತ್ತು ಸುಧಾರಿತ ಸೌಲಭ್ಯಗಳೊಂದಿಗೆ ಜಾಗತಿಕ ಗುಣಮಟ್ಟದ ಮೂಲಸೌಕರ್ಯಗಳನ್ನು ನಗರಕ್ಕೆ ನೀಡಲಿದೆ.',
      highlight: 'ಬಿಬಿಸಿಯೊಂದಿಗೆ, ಬೆಂಗಳೂರು ಜಾಗತಿಕ ನಗರಕ್ಕೆ ತಕ್ಕ ಸಾರಿಗೆ ಬೆನ್ನೆಲುಬನ್ನು ಹೊಂದಲಿದೆ.',
      cmStatement: [
        'ಕರ್ನಾಟಕದ ಬೆಳವಣಿಗೆಯು ಸಮಗ್ರ ಮತ್ತು ಭವಿಷ್ಯಕ್ಕೆ ಸಿದ್ಧವಾಗಿರಬೇಕು. ಭಾರತದ ನಾವೀನ್ಯತೆಯ ಕೇಂದ್ರವಾದ ಬೆಂಗಳೂರು, ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್ ಮೂಲಕ ತನ್ನ ಮುಂದಿನ ಹಂತವನ್ನು ಪ್ರವೇಶಿಸಲಿದೆ. ಮೂಲಸೌಕರ್ಯ ಯೋಜನೆಗಿಂತ ಹೆಚ್ಚಾಗಿ, ಇದು ಜನಸಂದಣಿಯನ್ನು ಕಡಿಮೆ ಮಾಡುವ, ಸಮತೋಲಿತ ಅಭಿವೃದ್ಧಿ ಮತ್ತು ಸುಸ್ಥಿರತೆಯ ದೃಷ್ಟಿಯಾಗಿದೆ.',
        'ನಗರದ ಪರಿಧಿಯನ್ನು ಜಾಗತಿಕ ಮಟ್ಟದ ಸೌಲಭ್ಯಗಳೊಂದಿಗೆ ಸಂಪರ್ಕಿಸುವ ಮೂಲಕ, ನಾವು ಹೊಸ ಅವಕಾಶಗಳನ್ನು ಬಿಡುಗಡೆ ಮಾಡುತ್ತಿದ್ದೇವೆ, ಉದ್ಯೋಗಗಳನ್ನು ಸೃಷ್ಟಿಸುತ್ತಿದ್ದೇವೆ, ಜಾಗತಿಕ ಹೂಡಿಕೆಯನ್ನು ಆಕರ್ಷಿಸುತ್ತಿದ್ದೇವೆ ಮತ್ತು ಜೀವನದ ಗುಣಮಟ್ಟವನ್ನು ಸುಧಾರಿಸುತ್ತಿದ್ದೇವೆ. ಒಟ್ಟಿಗೆ, ನಾವು ಜಾಗತಿಕವಾಗಿ ಸ್ಪರ್ಧಾತ್ಮಕವಾಗಿರುವ, ಮಾನವೀಯ ಮತ್ತು ವಾಸಯೋಗ್ಯವಾದ ಬೆಂಗಳೂರನ್ನು ನಿರ್ಮಿಸುತ್ತಿದ್ದೇವೆ.'
      ],
      cmName: '— ಶ್ರೀ ಸಿದ್ದರಾಮಯ್ಯ, ಗೌರವಾನ್ವಿತ ಮುಖ್ಯಮಂತ್ರಿ',
      dcmStatement: [
        'ಬೆಂಗಳೂರು ಯಾವಾಗಲೂ ನಾವೀನ್ಯತೆ ಮತ್ತು ಕನಸುಗಳ ನಗರವಾಗಿದೆ. ಬೆಂಗಳೂರು ಅಭಿವೃದ್ಧಿ ಮತ್ತು ನಗರ ನಿಯೋಜನಾ ಸಚಿವರಾಗಿ, ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್ ನಗರದ ಬೆಳವಣಿಗೆಯನ್ನು ಪುನರ್ವ್ಯಾಖ್ಯಾನಿಸುವ ರೂಪಾಂತರಕಾರಿ ಉಪಕ್ರಮವಾಗಿದೆ ಎಂದು ನಾನು ನೋಡುತ್ತೇನೆ. ಪೆರಿಫೆರಲ್ ರಿಂಗ್ ರೋಡ್ ಮತ್ತು ಸಂಯೋಜಿತ ಮೂಲಸೌಕರ್ಯದೊಂದಿಗೆ, ನಾವು ಜನಸಂದಣಿಯನ್ನು ಕಡಿಮೆ ಮಾಡಲು, ಹೊಸ ಆರ್ಥಿಕ ವಲಯಗಳನ್ನು ಬಿಡುಗಡೆ ಮಾಡಲು ಮತ್ತು ಸಮತೋಲಿತ ಅಭಿವೃದ್ಧಿಯನ್ನು ಖಾತ್ರಿಪಡಿಸಲು ಗುರಿಯಿಟ್ಟಿದ್ದೇವೆ.',
        'ರಸ್ತೆಗಳಿಗಿಂತ ಹೆಚ್ಚಾಗಿ, ಈ ಯೋಜನೆಯು ಉತ್ತಮ ಅವಕಾಶಗಳು, ಸ್ವಚ್ಛವಾದ ಪರಿಸರ ಮತ್ತು ಸುಧಾರಿತ ಜೀವನದ ಗುಣಮಟ್ಟವನ್ನು ಭರವಸೆ ನೀಡುತ್ತದೆ. ಭವಿಷ್ಯದ ಪೀಳಿಗೆಗಳಿಗೆ ಹಸ್ತಾಂತರಿಸಲು ನಾವು ಹೆಮ್ಮೆಪಡುವ ನಗರವನ್ನು ರೂಪಿಸುವಲ್ಲಿ ಪ್ರತಿಯೊಬ್ಬ ಬೆಂಗಳೂರಿನವರೂ ಇದನ್ನು ತಮ್ಮದೇ ಯೋಜನೆಯಾಗಿ ಮಾಡಲು ನಾನು ಆಹ್ವಾನಿಸುತ್ತೇನೆ.'
      ],
      dcmName: '— ಶ್ರೀ ಡಿ.ಕೆ. ಶಿವಕುಮಾರ್, ಗೌರವಾನ್ವಿತ ಮುಖ್ಯಮಂತ್ರಿ',
      mlaStatement: [
        'ಬೆಂಗಳೂರಿನ ಭವಿಷ್ಯವು ಯೋಜಿತ, ಸಮಗ್ರ ಮತ್ತು ಜನ-ಕೇಂದ್ರಿತ ಅಭಿವೃದ್ಧಿಯನ್ನು ಅವಲಂಬಿಸಿದೆ. ಜನರ ಪ್ರತಿನಿಧಿಯಾಗಿ, ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್ ಜನಸಂದಣಿಯನ್ನು ಕಡಿಮೆ ಮಾಡುವ, ಸಮತೋಲಿತ ಬೆಳವಣಿಗೆಯನ್ನು ಉತ್ತೇಜಿಸುವ ಮತ್ತು ನಮ್ಮ ನೆರೆಹೊರೆಗಳಿಗೆ ಅಭಿವೃದ್ಧಿಯನ್ನು ಹತ್ತಿರಕ್ಕೆ ತರುವ ನಿರ್ಣಾಯಕ ಉಪಕ್ರಮವಾಗಿದೆ ಎಂದು ನಾನು ನೋಡುತ್ತೇನೆ.',
        'ಸಂಪರ್ಕವನ್ನು ಬಲಪಡಿಸುವ ಮತ್ತು ಹೊಸ ಆರ್ಥಿಕ ಅವಕಾಶಗಳನ್ನು ಸೃಷ್ಟಿಸುವ ಮೂಲಕ, ಕಾರಿಡಾರ್ ಸ್ಥಳೀಯ ಸಮುದಾಯಗಳು, ಸಣ್ಣ ವ್ಯವಹಾರಗಳು ಮತ್ತು ನಮ್ಮ ನಗರದ ಯುವಜನತೆಗೆ ಲಾಭ ನೀಡುತ್ತದೆ. ಈ ಯೋಜನೆಯು ಬೆಂಗಳೂರಿನವರ ದೈನಂದಿನ ಜೀವನವನ್ನು ಸುಧಾರಿಸುತ್ತದೆ ಮತ್ತು ಹೆಚ್ಚು ಸಮಾನತಾಪೂರ್ಣ ಮತ್ತು ಸುಸ್ಥಿರ ಬೆಂಗಳೂರಿಗೆ ಕೊಡುಗೆ ನೀಡುತ್ತದೆ ಎಂದು ನನಗೆ ವಿಶ್ವಾಸವಿದೆ.'
      ],
      mlaName: '— ಶ್ರೀ ಎನ್.ಎ. ಹರೀಸ್, ಗೌರವಾನ್ವಿತ ಶಾಸಕ',
      chairmanStatement: [
        'ನಮ್ಮ ನಗರವು ರೂಪಾಂತರದ ಕ್ಷಣದಲ್ಲಿ ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್ ಲಿಮಿಟೆಡ್ ಅನ್ನು ನೇತೃತ್ವ ವಹಿಸುವುದು ಗೌರವದ ವಿಷಯವಾಗಿದೆ. ಮೂಲಸೌಕರ್ಯ ಯೋಜನೆಗಿಂತ ಹೆಚ್ಚಾಗಿ, ಕಾರಿಡಾರ್ ವಾಣಿಜ್ಯ, ಸಮುದಾಯ ಮತ್ತು ಸುಸ್ಥಿರತೆ ಒಟ್ಟಿಗೆ ಉತ್ತುಂಗಕ್ಕೇರುವ ಹೊಸ ನಗರ ಪರಿಸರ ವ್ಯವಸ್ಥೆಯ ಅಡಿಪಾಯವಾಗಿದೆ.',
        'ಜಾಗತಿಕ ಉತ್ತಮ ಅಭ್ಯಾಸಗಳನ್ನು ಸ್ಥಳೀಯ ಆದ್ಯತೆಗಳೊಂದಿಗೆ ಸಂಯೋಜಿಸುವ ಮೂಲಕ, ಯೋಜನೆಯು ಜಾಗತಿಕ ಮಟ್ಟದ ರಸ್ತೆಗಳು, ಹಸಿರು ಚಲನಶೀಲತೆ, ಆರ್ಥಿಕ ಕ್ಲಸ್ಟರ್‌ಗಳು ಮತ್ತು ವಾಸಯೋಗ್ಯ ಪಟ್ಟಣಗಳನ್ನು ನೀಡುತ್ತದೆ. ಅಧ್ಯಕ್ಷರಾಗಿ, ನಾನು ಎಲ್ಲಾ ಹಿತಾಸಕ್ತಿಗಳಿಗೆ ಪಾರದರ್ಶಕತೆ, ಸಮರ್ಥತೆ ಮತ್ತು ಶ್ರೇಷ್ಠತೆಯ ಬಗ್ಗೆ ನಮ್ಮ ಬದ್ಧತೆಯನ್ನು ಖಾತ್ರಿಪಡಿಸುತ್ತೇನೆ. ಒಟ್ಟಿಗೆ, ನಾವು ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್ ಅನ್ನು ಭಾರತದಲ್ಲಿ ನಗರ ಅಭಿವೃದ್ಧಿಗೆ ಮಾನದಂಡವನ್ನಾಗಿ ಮಾಡುತ್ತೇವೆ.'
      ],
      chairmanName: '— ಶ್ರೀ ಎಲ್ ಕೆ ಅತೀಕ್, ಐ.ಎ.ಎಸ್ (ನಿವೃತ್ತ)\nಗೌರವಾನ್ವಿತ ಅಧ್ಯಕ್ಷ, ಬಿಬಿಸಿ',
      headline: '',
      bodyCopy: '',
      quickFactsTitle: 'ಪ್ರಮುಖ ಅಂಶಗಳು',
      quickFacts: [
        {
          heading: 'ಉತ್ತರ ಮತ್ತು ಪೂರ್ವ ಬೆಂಗಳೂರಿನಾದ್ಯಂತ 73.04 ಕಿ.ಮೀ ಅರ್ಧವೃತ್ತಾಕಾರದ ಕಾರಿಡಾರ್',
          content: 'ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್‌ ಕಾರಿಡಾರ್ ಅನ್ನು ನಗರದ ಉತ್ತರ ಮತ್ತು ಪೂರ್ವ ಭಾಗಗಳಲ್ಲಿ 73.04 ಕಿ.ಮೀ. ಉದ್ದದ ಅರ್ಧವೃತ್ತಾಕಾರದ ಕಾರಿಡಾರ್ ಆಗಿ ರೂಪಿಸಲಾಗಿದೆ.',
          readMoreContent: 'ಇದು ಬೆಂಗಳೂರಿನಾದ್ಯಂತ ಸಂಚಾರ ಮತ್ತು ಆರ್ಥಿಕ ಚಟುವಟಿಕೆಗಳ ಹರಿವನ್ನು ಆಮೂಲಾಗ್ರವಾಗಿ ಬದಲಾಯಿಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ. ನಗರದ ಪ್ರಮುಖ ಕೇಂದ್ರ ಭಾಗದಿಂದ ಹೊರ ವಲಯದ ಕಡೆಗೆ ಹೊರಮುಖವಾಗಿ ಸಾಗುವ ಕಾರಿಡಾರ್‌ಗಳ ನಡುವೆ ನಿರಂತರ ಸಾಮರ್ಥ್ಯದ ಸಂಪರ್ಕವನ್ನು ಒದಗಿಸುವ ಮೂಲಕ, ಬಿಬಿಸಿ ದೂರದ ಮತ್ತು ನಗರವನ್ನು ದಾಟುವ ಸಂಚಾರಕ್ಕೆ ನಗರದ ಮಧ್ಯಭಾಗವನ್ನು ಪ್ರವೇಶಿಸದೇ ಬೈಪಾಸ್ ಮಾಡಲು ಅನುವು ಮಾಡಿಕೊಡುತ್ತದೆ. ಇದು ಸಂಪರ್ಕಜಾಲದ ದಕ್ಷತೆಯನ್ನು ಸುಧಾರಿಸುವುದಲ್ಲದೆ, ಯೋಜಿತ ರೀತಿಯಲ್ಲಿ ಬೆಂಗಳೂರಿನ ಹೊರಗಿನ ವಿಸ್ತರಣೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.'
        },
        {
          heading: 'ಹಸಿರು ಬಫರ್‌ಗಳೊಂದಿಗೆ 100 ಮೀಟರ್ \'ರೈಟ್-ಆಫ್-ವೇ\' (RoW)',
          content: '100-ಮೀಟರ್ \'ರೈಟ್-ಆಫ್-ವೇ\' (RoW) ವ್ಯಾಪ್ತಿಯಲ್ಲಿ ನಿರ್ಮಾಣವಾಗುತ್ತಿರುವ ಬಿಬಿಸಿ, ಕೇವಲ ರಸ್ತೆಯಾಗಿರದೆ ಒಂದು ಸಮಗ್ರ ನಗರ ಯೋಜನೆಯಾಗಿ ಹೊರಹೊಮ್ಮಲಿದೆ.',
          readMoreContent: 'ಇದು ವಾಹನ ಸಂಚಾರದ ಜೊತೆಗೆ, ವಿದ್ಯುತ್ ಮತ್ತು ನೀರಿನಂತಹ ಮೂಲಭೂತ ಸೌಕರ್ಯ ಮಾರ್ಗಗಳು ಹಾಗೂ ಪಾದಚಾರಿ ಮತ್ತು ಸೈಕಲ್ ಸವಾರರಿಗೆ ಪ್ರತ್ಯೇಕ ಪಥಗಳನ್ನು ಒಂದೇ ಸೂರಿನಡಿ ತರುತ್ತದೆ. ಇಲ್ಲಿನ ಹಸಿರಿನಿಂದ ಅಚ್ಛಾದಿತವಾದ ಪ್ರದೇಶ (Green Landscape) ಮತ್ತು ತೆರೆದ ಸ್ಥಳಗಳು ಶಬ್ದ ಮಾಲಿನ್ಯವನ್ನು ತಗ್ಗಿಸಿ, ಪರಿಸರಕ್ಕೆ ಪೂರಕವಾದ ವಾತಾವರಣವನ್ನು ಸೃಷ್ಟಿಸುತ್ತವೆ. ಹೀಗಾಗಿ, ಇದು ಬರೀ ಕಾಂಕ್ರೀಟ್ ರಸ್ತೆಯಾಗದೆ, ಭವಿಷ್ಯದ ಬೆಂಗಳೂರಿಗೆ ಅಗತ್ಯವಾದ ಸುಸ್ಥಿರ ಮತ್ತು ಪರಿಸರ ಸ್ನೇಹಿ ಸಂಪರ್ಕ ಕೊಂಡಿಯಾಗಲಿದೆ.'
        },
        {
          heading: 'ರಾಷ್ಟ್ರೀಯ ಮತ್ತು ರಾಜ್ಯ ಹೆದ್ದಾರಿಗಳನ್ನು ಸಂಪರ್ಕಿಸುವ 10 ಪ್ರಮುಖ ಇಂಟರ್‌ಚೇಂಜ್‌ಗಳು',
          content: 'ಬೆಂಗಳೂರಿನ ಉತ್ತರ-ದಕ್ಷಿಣ ಮತ್ತು ಪೂರ್ವ-ಪಶ್ಚಿಮ ಭಾಗಗಳ ನಡುವಿನ ವಾಹನ ಸಂಚಾರವು ಪ್ರಸ್ತುತ ನಗರದ ಒಳಗಿನ ರಸ್ತೆಗಳನ್ನೇ ಅವಲಂಬಿಸಿದೆ. ಇದನ್ನು ತಪ್ಪಿಸಲು ಪ್ರಮುಖ ಸ್ಥಳಗಳಲ್ಲಿ ಬಹು-ಮಹಡಿ ಮೇಲ್ಸೇತುವೆಗಳನ್ನು (Grade-Separated Interchanges) ನಿರ್ಮಿಸಲಾಗುತ್ತಿದೆ.',
          readMoreContent: 'ಇವುಗಳ ಮೂಲಕ ವಾಹನಗಳು ನಗರದೊಳಗೆ ಬಾರದೇ ಹೊರವಲಯದಲ್ಲೇ ತಡೆರಹಿತವಾಗಿ ಸಂಚರಿಸಬಹುದು. ಇದರಿಂದ ನಗರದ ಪ್ರಮುಖ ರಸ್ತೆಗಳಲ್ಲಿ ಟ್ರಾಫಿಕ್ ಜಾಮ್ ಕಡಿಮೆಯಾಗಲಿದ್ದು, ಸುತ್ತಮುತ್ತಲಿನ ಪ್ರದೇಶಗಳ ಸಂಪರ್ಕ ವ್ಯವಸ್ಥೆ ಸುಧಾರಿಸಲಿದೆ.'
        },
        {
          heading: 'ತಡೆರಹಿತ ಸಂಪರ್ಕಕ್ಕಾಗಿ ಮೀಸಲಾದ 5 ರೈಲ್ವೆ ಕ್ರಾಸಿಂಗ್‌ಗಳು (ROB/RUB):',
          content: 'ತಡೆರಹಿತ ಸಂಚಾರಕ್ಕಾಗಿ, ರೈಲ್ವೆ ಹಳಿಗಳು ಬರುವ ಐದು ಸ್ಥಳಗಳಲ್ಲಿ ಮೇಲ್ಸೇತುವೆ (ROB) ಮತ್ತು ಕೆಳಸೇತುವೆಗಳನ್ನು (RUB) ಈ ಯೋಜನೆಯಲ್ಲಿ ಅಳವಡಿಸಲಾಗಿದೆ.',
          readMoreContent: 'ಈ ವ್ಯವಸ್ಥೆಯು ರಸ್ತೆ ಮತ್ತು ರೈಲು ಸಂಚಾರವನ್ನು ಬೇರ್ಪಡಿಸುವುದರಿಂದ, ವಾಹನಗಳು ರೈಲಿಗಾಗಿ ಕಾಯುವ (Level Crossing) ಸಮಯ ಉಳಿತಾಯವಾಗುತ್ತದೆ. ಅಲ್ಲದೆ, ಇದು ಭವಿಷ್ಯದ ರೈಲ್ವೆ ಅಭಿವೃದ್ಧಿಗೂ ಅಡ್ಡಿಯಾಗದಂತೆ ನೋಡಿಕೊಳ್ಳಲಿದ್ದು, ಸರಕು ಸಾಗಣೆ ಮತ್ತು ದೂರದ ಸಂಚಾರಕ್ಕೆ ಮುಕ್ತ ಮಾರ್ಗವನ್ನು ಕಲ್ಪಿಸುತ್ತದೆ.'
        },
        {
          heading: 'ಭೂಸ್ವಾಧೀನವನ್ನೂ ಒಳಗೊಂಡಂತೆ ₹26,786 ಕೋಟಿ ಹೂಡಿಕೆ',
          content: 'ಭೂಸ್ವಾಧೀನ ಸೇರಿದಂತೆ ಸುಮಾರು ₹26,786 ಕೋಟಿ ವೆಚ್ಚದಲ್ಲಿ ಈ ಯೋಜನೆಯನ್ನು ರೂಪಿಸಲಾಗಿದೆ. ಇದು ಯೋಜನೆಯ ವ್ಯಾಪ್ತಿ ಮತ್ತು ದೀರ್ಘಕಾಲೀನ ಪ್ರಾಮುಖ್ಯತೆಗೆ ಸಾಕ್ಷಿಯಾಗಿದೆ.',
          readMoreContent: 'ಈ ಒಟ್ಟಾರೆ ಹೂಡಿಕೆಯು ನಿರ್ಮಾಣ ಕಾರ್ಯದ ಜೊತೆಗೆ, ಅಭಿವೃದ್ಧಿ, ಪುನರ್ವಸತಿ ಮತ್ತು ಆಧುನಿಕ ಮೂಲಸೌಕರ್ಯಗಳನ್ನು ಒಳಗೊಂಡಿದೆ. ಇದು ಕಾರಿಡಾರ್ ಅನ್ನು ಕೇವಲ ರಸ್ತೆಯನ್ನಾಗಿ ಅಲ್ಲ, ಬದಲಿಗೆ ದಶಕಗಳ ಕಾಲ ಜನರಿಗೆ ಸೇವೆ ನೀಡುವ, ಆರ್ಥಿಕ ಬೆಳವಣಿಗೆಗೆ ಪೂರಕವಾದ ಶಾಶ್ವತ ಸಾರ್ವಜನಿಕ ಆಸ್ತಿಯನ್ನಾಗಿ ರೂಪಿಸುವ ಗುರಿ ಹೊಂದಿದೆ.'
        },
        {
          heading: 'RoW ಒಳಗೆ ಕಾರಿಡಾರ್ ಉದ್ದಕ್ಕೂ 34 ಕಿ.ಮೀ. ವರೆಗೆ ಯೋಜಿತ ವಾಣಿಜ್ಯ ಅಭಿವೃದ್ಧಿ',
          content: 'ಸುಮಾರು 34 ಕಿ.ಮೀ. ಉದ್ದದ ರಸ್ತೆಯ ಇಕ್ಕೆಲಗಳಲ್ಲಿ (\'ರೈಟ್-ಆಫ್-ವೇ\' ಒಳಗೆ) ವಾಣಿಜ್ಯ ಅಭಿವೃದ್ಧಿಗೆ ಅವಕಾಶ ನೀಡಿರುವುದು ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್‌ ಕಾರಿಡಾರ್‌ನ ವಿಶೇಷತೆಯಾಗಿದೆ.',
          readMoreContent: 'ಈ ಯೋಜನೆಯು ಕೇವಲ ರಸ್ತೆಯಾಗಿರದೆ, ಉದ್ದಕ್ಕೂ ಹೊಸ ಉದ್ಯೋಗ ಮತ್ತು ಆರ್ಥಿಕ ಚಟುವಟಿಕೆಗಳನ್ನು ಸೃಷ್ಟಿಸುವ ಕೇಂದ್ರವಾಗಲಿದೆ. ಎಲ್ಲೆಂದರಲ್ಲಿ ಅಡ್ಡಾದಿಡ್ಡಿ ಬೆಳೆಯುವ ಬದಲು (Unplanned growth), ಅಚ್ಚುಕಟ್ಟಾದ ವಾಣಿಜ್ಯ ವಲಯಗಳನ್ನು ಇದು ಒಳಗೊಂಡಿರಲಿದೆ. ಈ ಮೂಲಕ, ಸಾರಿಗೆ ಸಂಪರ್ಕದ ಜೊತೆಗೆ ಆರ್ಥಿಕ ಅಭಿವೃದ್ಧಿಯನ್ನೂ ಸಾಧಿಸುವ ಮಹತ್ವದ ಕಾರಿಡಾರ್ ಆಗಿ ಇದು ಹೊರಹೊಮ್ಮಲಿದೆ.'
        }
      ]
    },

    // Quick Facts
    quickFacts: {
      title: 'ಪ್ರಮುಖ ಅಂಶಗಳ ಪಕ್ಷಿನೋಟ',
      scope: 'ವ್ಯಾಪ್ತಿ',
      scopeValue: 'ಉತ್ತರ ಮತ್ತು ಪೂರ್ವ ಬೆಂಗಳೂರನ್ನು ಸಂಪರ್ಕಿಸುವ 66.46 ಕಿ.ಮೀ ಅರ್ಧವರ್ತುಲಾಕಾರದ ರಸ್ತೆ',
      width: 'ವಿಶಾಲತೆ',
      widthValue: '100 ಮೀಟರ್ ಅಗಲದ ರಸ್ತೆ, ಎರಡೂ ಬದಿಗಳಲ್ಲಿ ಹಸಿರಿನಿಂದ ಕೂಡಿದ ಸುಂದರ ಪರಿಸರ',
      connectivity: 'ಸಂಪರ್ಕ',
      connectivityValue: 'ರಾಷ್ಟ್ರೀಯ ಮತ್ತು ರಾಜ್ಯ ಹೆದ್ದಾರಿಗಳನ್ನು ಜೋಡಿಸುವ 10 ಪ್ರಮುಖ ಇಂಟರ್‌ಚೇಂಜ್‌ಗಳು',
      smoothTravel: 'ಸುಗಮ ಸಂಚಾರ',
      smoothTravelValue: '5 ಸುಸಜ್ಜಿತ ರೈಲ್ವೆ ಕ್ರಾಸಿಂಗ್‌ಗಳು (ROB/RUB)',
      investment: 'ಹೂಡಿಕೆ',
      investmentValue: 'ಭೂಸ್ವಾಧೀನ ಸೇರಿದಂತೆ ಒಟ್ಟು ₹26,786 ಕೋಟಿ ಮೊತ್ತದ ಬೃಹತ್ ಯೋಜನೆ',
      commercial: 'ವಾಣಿಜ್ಯ ಅಭಿವೃದ್ಧಿ',
      commercialValue: 'ಕಾರಿಡಾರ್‌ನ 34 ಕಿ.ಮೀ. ಉದ್ದಕ್ಕೂ ವಾಣಿಜ್ಯ ಅಭಿವೃದ್ಧಿಗೆ ವಿಶೇಷ ಅವಕಾಶ'
    },

    // Project Section
    project: {
      title: 'ಯೋಜನೆ',
      subtitle: 'ಬೆಂಗಳೂರಿನ ಸುತ್ತ ತಡೆರಹಿತ ಸಂಪರ್ಕ',
      description1: 'ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್‌ ಕಾರಿಡಾರ್‌ನ್ನು ಅತ್ಯಂತ ವ್ಯವಸ್ಥಿತವಾಗಿ ರೂಪಿಸಲಾಗಿದೆ. ಇದು ತುಮಕೂರು ರಸ್ತೆಯಿಂದ (NH-4, ಮಾದಾವರ) ಆರಂಭವಾಗಿ, ನಗರದ ಉತ್ತರ ಮತ್ತು ಪೂರ್ವ ಭಾಗಗಳನ್ನು ದಾಟಿ, ದಕ್ಷಿಣ ಭಾಗದಲ್ಲಿರುವ ಹೊಸೂರು ರಸ್ತೆಯನ್ನು (ಕೋಣಪ್ಪನ ಅಗ್ರಹಾರ) ತಲುಪುತ್ತದೆ. ಎರಡು ಕಡೆಗಳಲ್ಲೂ ಇದು ನೈಸ್ (NICE) ರಸ್ತೆಯೊಂದಿಗೆ ಸೇರಿ ಬೆಂಗಳೂರಿನ ಸುತ್ತ ಒಂದು ಸಂಪೂರ್ಣ ವರ್ತುಲಾಕಾರದ ರಸ್ತೆ ಜಾಲವನ್ನು ನಿರ್ಮಿಸುತ್ತದೆ.',
      keyInterchanges: 'ಪ್ರಮುಖ ಇಂಟರ್‌ಚೇಂಜ್‌ಗಳು',
      keyPlan: 'ಬಿಬಿಸಿ ಬ್ಲೂ ಪ್ರಿಂಟ್',
      keyPlanDesc: 'ಬೆಂಗಳೂರಿನ ಸಾರಿಗೆ ವ್ಯವಸ್ಥೆಗೆ ಹೊಸ ರೂಪ ನೀಡಲಿರುವ ಬಿಬಿಸಿ ಯೋಜನೆಯ \'ಕ್ರಾಸ್-ಸೆಕ್ಷನ್\' (Cross-section) ವಿನ್ಯಾಸವನ್ನು ವೀಕ್ಷಿಸಲು ಇಲ್ಲಿ ವೀಕ್ಷಿಸಿ',
      downloadKeyPlan: 'ಬಿಬಿಸಿ ಬ್ಲೂ ಪ್ರಿಂಟ್ ವೀಕ್ಷಿಸಿ (PDF)',
      prr1Button: 'PRR-1 ವಿವರವಾದ ಜೋಡಣೆಯನ್ನು ವೀಕ್ಷಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ',
      prr1ButtonEnvironmentClearance: 'ಈ ಯೋಜನೆಯ ಪರಿಸರ ಅನುಮತಿಪತ್ರವನ್ನು ವೀಕ್ಷಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ',
      sections: '3 ವಿಭಾಗಗಳು',
      sectionsLabel: 'ಹಂತ ಹಂತದ ನಿರ್ಮಾಣಕ್ಕಾಗಿ',
      interchanges: '10 ಇಂಟರ್‌ಚೇಂಜ್‌ಗಳು',
      interchangesLabel: 'ಪ್ರಮುಖ ಹೆದ್ದಾರಿ ಸಂಧಿಗಳಲ್ಲಿ',
      robRub: '5 ROB/RUBಗಳು',
      robRubLabel: 'ರೈಲ್ವೆ ಕ್ರಾಸಿಂಗ್‌ಗಳು'
    },

    // Interchanges
    interchanges: {
      title: 'PRR-1ರ 11 ಇಂಟರ್‌ಚೇಂಜ್‌ಗಳು',
      subtitle: 'ಪ್ರಮುಖ ಹೆದ್ದಾರಿ ಸಂಧಿಗಳಲ್ಲಿ',
      description: 'ಬಿಬಿಸಿ ಕಾರಿಡಾರ್ ಉದ್ದಕ್ಕೂ ಪ್ರಮುಖ ಸ್ಥಳಗಳಲ್ಲಿ ಗ್ರೇಡ್-ಸೆಪರೇಟೆಡ್ ಇಂಟರ್‌ಚೇಂಜ್‌ಗಳು ಮತ್ತು ಗ್ರೇಡ್ ಸೆಪರೇಟರ್‌ಗಳನ್ನು ನಿರ್ಮಿಸಲಾಗುತ್ತಿದೆ.'
    },

    // Design & Safety
    design: {
      title: 'ವಿನ್ಯಾಸ ಮತ್ತು ಸುರಕ್ಷತೆ',
      subtitle: 'ಅತ್ಯಾಧುನಿಕ ವಿನ್ಯಾಸ, ಸುರಕ್ಷಿತ ಪ್ರಯಾಣ',
      description: 'ಈ ಕಾರಿಡಾರ್ ಕೇವಲ ವಾಹನ ಸಂಚಾರಕ್ಕಷ್ಟೇ ಸೀಮಿತವಾಗಿಲ್ಲ, ಇದು ಸರ್ವತೋಮುಖ ಸೌಲಭ್ಯಗಳ ಆಗರ:',
      features: {
        expressway: {
          heading: 'ಎಂಟು ಪಥದ ಎಕ್ಸ್‌ಪ್ರೆಸ್‌ವೇ',
          content: 'ಬೆಂಗಳೂರಿನಲ್ಲಿ ವಾಹನಗಳ ಸಂಖ್ಯೆ ಕೇವಲ ಹತ್ತು ವರ್ಷಗಳಲ್ಲಿ ದ್ವಿಗುಣಗೊಂಡಿದೆ. ಇದನ್ನು ಸಮರ್ಥವಾಗಿ ನಿಭಾಯಿಸಲು, ಕಾರಿಡಾರ್ ಅನ್ನು 8-ಪಥದ ಎಕ್ಸ್‌ಪ್ರೆಸ್‌ವೇ ಆಗಿ ಅಭಿವೃದ್ಧಿಪಡಿಸಲಾಗುತ್ತಿದೆ.',
          readMoreContent: 'ನಗರದ ಒಳಗಿನ ರಸ್ತೆಗಳ ಸಂಚಾರಕ್ಕೆ ತೊಂದರೆಯಾಗದಂತೆ ಹೊರವಲಯದ ಸಂಚಾರವನ್ನು ನಿರ್ವಹಿಸಲು ಇದು ಸಹಕಾರಿ. ಇಂಡಿಯನ್ ರೋಡ್ಸ್ ಕಾಂಗ್ರೆಸ್ (IRC) ಮಾನದಂಡಗಳ ಪ್ರಕಾರ ನಿರ್ಮಿಸಲಾಗುತ್ತಿರುವ ಈ ರಸ್ತೆ, ಸರಕು ಸಾಗಾಟ ಮತ್ತು ದೂರದ ಪ್ರಯಾಣಕ್ಕೆ ಸುರಕ್ಷಿತ ಮತ್ತು ವೇಗದ ಹಾದಿಯನ್ನು ಕಲ್ಪಿಸುತ್ತದೆ.'
        },
        median: {
          heading: '4-ಮೀಟರ್ ರಸ್ತೆ ವಿಭಜಕ',
          content: 'ರಸ್ತೆಯ ಮಧ್ಯಭಾಗದಲ್ಲಿರುವ 4 ಮೀಟರ್ ಅಗಲದ ಜಾಗವನ್ನು ಸಂಪೂರ್ಣವಾಗಿ ಗಿಡ-ಮರಗಳನ್ನು ಬೆಳೆಸಲು ಮೀಸಲಿಡಲಾಗಿದ್ದು, ಇದು ರಸ್ತೆಯ ಅಂದವನ್ನು ಹೆಚ್ಚಿಸುತ್ತದೆ.',
          readMoreContent: 'ಅಲ್ಲದೆ, ರಾತ್ರಿ ವೇಳೆ ಎದುರಿನ ವಾಹನಗಳ ಹೆಡ್‌ಲೈಟ್ ಬೆಳಕು ಚಾಲಕರ ಕಣ್ಣಿಗೆ ಬೀಳದಂತೆ (Glare barrier) ತಡೆಯುತ್ತದೆ. ಅಲ್ಲದೆ, ರಸ್ತೆಯುದ್ದಕ್ಕೂ ವಾತಾವರಣದ ಸಮತೋಲನವನ್ನು ಕಾಪಾಡಿಕೊಳ್ಳಲು ಇದು ಸಹಾಯ ಮಾಡುತ್ತದೆ. ಪರಿಸರ ಸ್ನೇಹಿ ಅಭಿವೃದ್ಧಿಗೆ ಯೋಜನೆಯು ನೀಡಿರುವ ಒತ್ತಿಗೆ ಇದು ಸಾಕ್ಷಿಯಾಗಿದೆ.'
        },
        serviceRoads: {
          heading: 'ಸರ್ವಿಸ್ ರಸ್ತೆಗಳು',
          content: 'ಕಾರಿಡಾರ್‌ನ ನಗರದ ಕಡೆಗೆ 11 ಮೀಟರ್ ಮತ್ತು ಹೊರಬದಿಯಲ್ಲಿ 7 ಮೀಟರ್ ಅಗಲದ ಸರ್ವಿಸ್ ರಸ್ತೆಗಳನ್ನು ನಿರ್ಮಿಸಲಾಗುತ್ತಿದೆ.',
          readMoreContent: 'ಲೋಕಲ್ ಟ್ರಾಫಿಕ್ ಮತ್ತು ಹೈವೇ ಟ್ರಾಫಿಕ್ ಒಂದಕ್ಕೊಂದು ಬೆರೆಯದಂತೆ ನೋಡಿಕೊಳ್ಳುವುದು ಇದರ ಉದ್ದೇಶ. ಇದರಿಂದ ಅಕ್ಕಪಕ್ಕದ ಬಡಾವಣೆಗಳಿಗೆ ಸುರಕ್ಷಿತವಾಗಿ ಹೋಗಿಬರಲು ಸಾಧ್ಯವಾಗುತ್ತದೆ. ಎಕ್ಸ್‌ಪ್ರೆಸ್‌ವೇ ಮತ್ತು ಸರ್ವಿಸ್ ರಸ್ತೆಯ ವಾಹನಗಳ ನಡುವಿನ ಗೊಂದಲವನ್ನು ಇದು ನಿವಾರಿಸುವುದರಿಂದ, ಟ್ರಾಫಿಕ್ ಜಾಮ್ ಇಲ್ಲದೆ ವಾಹನಗಳು ಸರಾಗವಾಗಿ ಚಲಿಸಲು ಸಾಧ್ಯವಾಗುತ್ತದೆ.'
        },
        cycleTracks: {
          heading: 'ಸೈಕಲ್ ಟ್ರ್ಯಾಕ್‌ಗಳು',
          content: 'ಪರಿಸರ ಸ್ನೇಹಿ ಸಾರಿಗೆಗೆ ಒತ್ತು ನೀಡಲು, ರಸ್ತೆಯುದ್ದಕ್ಕೂ 2 ಮೀಟರ್ ಅಗಲದ ಪ್ರತ್ಯೇಕ ಸೈಕಲ್ ಟ್ರ್ಯಾಕ್‌ಗಳನ್ನು ನಿರ್ಮಿಸಲಾಗಿದೆ.',
          readMoreContent: 'ಸೈಕಲ್ ಸವಾರರ ಸುರಕ್ಷತೆಗಾಗಿ ಈ ಟ್ರ್ಯಾಕ್‌ಗಳನ್ನು ಮುಖ್ಯ ರಸ್ತೆಯ ಸಂಚಾರದಿಂದ ಸಂಪೂರ್ಣವಾಗಿ ಬೇರ್ಪಡಿಸಲಾಗಿದೆ. ಹತ್ತಿರದ ಸ್ಥಳಗಳಿಗೆ ಹೋಗಲು ವಾಹನಗಳನ್ನು ಬಳಸುವ ಬದಲು ಸೈಕಲ್ ಬಳಸುವುದನ್ನು ಉತ್ತೇಜಿಸುವುದರ ಮೂಲಕ ಪರಿಸರಸ್ನೇಹಿ ಉಪಕ್ರಮಗಳಿಗೆ ಉತ್ತೇಜನ ನೀಡುವುದು ಮತ್ತು ಸುರಕ್ಷಿತ ಪ್ರಯಾಣಕ್ಕೆ ಅನುವು ಮಾಡಿಕೊಡುವುದು ಇದರ ಉದ್ದೇಶ.'
        },
        footpaths: {
          heading: 'ಪಾದಚಾರಿ ಮಾರ್ಗಗಳು',
          content: 'ಪಾದಚಾರಿಗಳು ಸುರಕ್ಷಿತವಾಗಿ ಮತ್ತು ನೆಮ್ಮದಿಯಿಂದ ನಡೆಯಲು, ರಸ್ತೆಯ ಬದಿಯಲ್ಲಿ 3 ಮೀಟರ್ ಅಗಲದ ಫುಟ್‌ಪಾತ್ ನಿರ್ಮಿಸಲಾಗಿದೆ.',
          readMoreContent: 'ಇದು ಭಾರತೀಯ ರಸ್ತೆ ಕಾಂಗ್ರೆಸ್ (IRC) ನಿಯಮಗಳ ಪ್ರಕಾರವಿದ್ದು, ವಾಹನಗಳ ಬದಲಾಗಿ ಕಾಲ್ನಡಿಗೆಯಲ್ಲೇ ದಾರಿಯನ್ನು ಕ್ರಮಿಸುವುದಕ್ಕೆ ಉತ್ತೇಜನ ನೀಡುತ್ತದೆ. ಅಕ್ಕಪಕ್ಕದ ಮನೆಗಳು ಮತ್ತು ಅಂಗಡಿಗಳಿಗೆ ಹೋಗಲು ಇದು ಅನುಕೂಲಕರವಾಗಿದ್ದು, ವಾಹನಗಳ ಭಯವಿಲ್ಲದೆ ಎಲ್ಲರೂ ರಸ್ತೆಯನ್ನು ಬಳಸಲು (Inclusivity) ಇದು ಅವಕಾಶ ಮಾಡಿಕೊಡುತ್ತದೆ.'
        },
        utilities: {
          heading: 'ಅಂತರ್ಗತ ಭೂಕಾಲುವೆಗಳು',
          content: 'ವಿದ್ಯುತ್, ನೀರು ಮತ್ತು ಇಂಟರ್ನೆಟ್ ಕೇಬಲ್‌ಗಳನ್ನು ಅಳವಡಿಸಲು ರಸ್ತೆಯ ಅಡಿಯಲ್ಲಿಯೇ ಪ್ರತ್ಯೇಕವಾದ ಪೈಪ್‌ಲೈನ್ ಅಥವಾ ಡಕ್ಟ್ ವ್ಯವಸ್ಥೆಯನ್ನು ಕಲ್ಪಿಸಲಾಗಿದೆ.',
          readMoreContent: 'ಇದರಿಂದಾಗಿ ಕೇಬಲ್ ಅಥವಾ ಪೈಪ್ ರಿಪೇರಿಗಾಗಿ ಭವಿಷ್ಯದಲ್ಲಿ ರಸ್ತೆ ಅಗೆಯುವ ಅಗತ್ಯವಿರುವುದಿಲ್ಲ. ಇದು ನಿರ್ವಹಣೆಗೆ ಸುಲಭವಾಗಿದ್ದು, ನಗರ ಬೆಳೆದಂತೆ ಹೆಚ್ಚುವರಿ ಸೌಲಭ್ಯಗಳನ್ನು ಅಳವಡಿಸಲು ಅನುಕೂಲ ಮಾಡಿಕೊಡುತ್ತದೆ.'
        },
        solarLights: 'ಸೌರಚಾಲಿತ ಬೀದಿದೀಪಗಳು',
        solarLightsDesc: 'ರಸ್ತೆಯಲ್ಲಿ ಅಳವಡಿಸಲಾದ ಸೋಲಾರ್ ದೀಪಗಳು ರಾತ್ರಿ ವೇಳೆ ಉತ್ತಮ ಬೆಳಕನ್ನು ನೀಡುವ ಮೂಲಕ ಸುರಕ್ಷತೆಯನ್ನು ಖಾತ್ರಿಪಡಿಸುತ್ತವೆ. ಸಾಂಪ್ರದಾಯಿಕ ವಿದ್ಯುತ್ ಮೇಲಿನ ಅವಲಂಬನೆಯನ್ನು ಕಡಿಮೆ ಮಾಡಿ, ದೀರ್ಘಾವಧಿಯ ಖರ್ಚು ಉಳಿಸುವುದು ಹಾಗೂ ಹಸಿರು ಇಂಧನದ ಬಳಕೆಗೆ ಒತ್ತು ನೀಡುವುದು ಇದರ ಉದ್ದೇಶ.',
        safety: {
          heading: 'ಸುರಕ್ಷತೆಗೆ ಮೊದಲ ಆದ್ಯತೆ',
          content: 'ಪ್ರಯಾಣಿಕರ ಸುರಕ್ಷತೆಗಾಗಿ, ರಸ್ತೆಯುದ್ದಕ್ಕೂ ಐಆರ್‌ಸಿ ಗುಣಮಟ್ಟದ ತಡೆಗೋಡೆಗಳು ಮತ್ತು ಎಚ್ಚರಿಕೆ ಫಲಕಗಳನ್ನು ಅಳವಡಿಸಲಾಗಿದೆ.',
          readMoreContent: 'ರಾತ್ರಿ ವೇಳೆ ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣುವ ರೇಡಿಯಂ ಸೂಚಕಗಳು ಮತ್ತು ಪಾದಚಾರಿಗಳಿಗೆ ಪ್ರತ್ಯೇಕ ರಕ್ಷಣಾ ಬೇಲಿಗಳನ್ನು ಅಳವಡಿಸಲಾಗಿದೆ. ಅಪಘಾತಗಳನ್ನು ತಡೆಯುವುದು ಮತ್ತು ಮಳೆ ಅಥವಾ ರಾತ್ರಿ ವೇಳೆಯಲ್ಲೂ ಚಾಲಕರಿಗೆ ಮತ್ತು ಪಾದಚಾರಿಗಳಿಗೆ ರಸ್ತೆ ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣುವಂತೆ ಮಾಡುವುದು ಇದರ ಮುಖ್ಯ ಉದ್ದೇಶ.'
        },
        signboards: {
          heading: 'ಮಾರ್ಗಸೂಚಿ ಫಲಕಗಳು',
          content: 'ಪ್ರಯಾಣಿಕರ ಅನುಕೂಲಕ್ಕಾಗಿ, ಹೆದ್ದಾರಿಯುದ್ದಕ್ಕೂ ಊರುಗಳ ಹೆಸರು ಮತ್ತು ದೂರವನ್ನು ತೋರಿಸುವ ಸ್ಪಷ್ಟವಾದ ಬೋರ್ಡ್‌ಗಳನ್ನು ಅಳವಡಿಸಲಾಗಿದೆ.',
          readMoreContent: 'ನಿರ್ಗಮನ ಅಥವಾ ತಿರುವುಗಳು ಬರುವ ಮುಂಚೆಯೇ ಈ ಫಲಕಗಳು ಕಾಣಸಿಗುತ್ತವೆ. ಇದರಿಂದ ಚಾಲಕರಿಗೆ ತಾವು ಚಲಿಸುತ್ತಿರುವ ದಾರಿಯ ಬಗ್ಗೆ ಸ್ಪಷ್ಟತೆ ಸಿಗುತ್ತದೆ. ಗೊಂದಲವಿಲ್ಲದೆ ಸರಿಯಾದ ಮಾರ್ಗದಲ್ಲಿ ಹೋಗಲು ಮತ್ತು ಟ್ರಾಫಿಕ್ ಜಾಮ್ ತಡೆಯಲು ಇದು ಸಹಕಾರಿಯಾಗಿದೆ.'
        }
      },
      // footer: 'ಚಲನಶೀಲತೆ, ಸುರಕ್ಷತೆ ಮತ್ತು ಭವಿಷ್ಯದ ಸಿದ್ಧತೆಯ ಈ ಸಂಯೋಜನೆಯು ಬಿಬಿಸಿ ಕಾರಿಡಾರ್ ಅನ್ನು ಭಾರತದ ರಸ್ತೆ ವಿನ್ಯಾಸದಲ್ಲಿ ಒಂದು ಮೈಲಿಗಲ್ಲಾಗಿ ಮಾಡುತ್ತದೆ.'
    },

    // Mobility & Tolling
    mobility: {
      title: 'ಸ್ಮಾರ್ಟ್ ಟೋಲಿಂಗ್ ವ್ಯವಸ್ಥೆ',
      subtitle: 'ಸ್ಮಾರ್ಟ್ ಟೋಲಿಂಗ್ – ತಡೆರಹಿತ ಪ್ರಯಾಣ',
      description: 'ಇಲ್ಲಿ ಟೋಲ್ ಕೇಂದ್ರಗಳಲ್ಲಿ ಸಾಲುಗಟ್ಟಿ ನಿಲ್ಲುವ ಅಥವಾ ನಗದು ಪಾವತಿಗಾಗಿ ಕಾಯುವ ಕಿರಿಕಿರಿ ಇರುವುದಿಲ್ಲ. ಬಿಬಿಸಿಯಲ್ಲಿ \'ಕ್ಲೋಸ್ಡ್ ಟೋಲಿಂಗ್\' (Closed Tolling) ವ್ಯವಸ್ಥೆಯನ್ನು ಜಾರಿಗೊಳಿಸಲಾಗುತ್ತದೆ. ಇದರ ವಿಶೇಷತೆ ಎಂದರೆ, ಪ್ರಯಾಣಿಕರು ರಸ್ತೆಯಲ್ಲಿ ಎಷ್ಟು ದೂರ ಪ್ರಯಾಣಿಸುತ್ತಾರೋ ಅಷ್ಟಕ್ಕೆ ಮಾತ್ರ ಹಣ ಪಾವತಿಸಿದರೆ ಸಾಕು. ವೇಗ ಮತ್ತು ಸೌಕರ್ಯವನ್ನು ಗಮನದಲ್ಲಿಟ್ಟುಕೊಂಡು ಈ ವ್ಯವಸ್ಥೆಯನ್ನು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ:',
      features: {
        etc: {
          heading: 'ಎಲೆಕ್ಟ್ರಾನಿಕ್ ಟೋಲ್ ಸಂಗ್ರಹಣೆ (ETC)',
          content: 'ಬಿಬಿಸಿ ಕಾರಿಡಾರ್‌ನಲ್ಲಿ ಸ್ಮಾರ್ಟ್ ಎಲೆಕ್ಟ್ರಾನಿಕ್ ಟೋಲಿಂಗ್ ವ್ಯವಸ್ಥೆಯಿದೆ. \'ಆನ್-ಬೋರ್ಡ್ ಯುನಿಟ್\' (OBU) ಇರುವ ವಾಹನಗಳು ಟೋಲ್ ಪ್ಲಾಜಾದಲ್ಲಿ ನಿಲ್ಲದೆ ನೇರವಾಗಿ ಹೋಗಬಹುದು.',
          readMoreContent: 'ಇದರಿಂದ ಸುಂಕ ವಸೂಲಾತಿ ಕೇಂದ್ರದದಲ್ಲಿ ಸರತಿ ಸಾಲಿನಲ್ಲಿ ನಿಲ್ಲುವುದು ತಪ್ಪುತ್ತದೆ, ಪೆಟ್ರೋಲ್/ಡೀಸೆಲ್ ಉಳಿತಾಯವಾಗುತ್ತದೆ ಮತ್ತು ನಿಗದಿತ ಸಮಯಕ್ಕೆ ತಲುಪಲು ಸಾಧ್ಯವಾಗುತ್ತದೆ. ವಾಹನಗಳು ಎಲ್ಲಿಯೂ ನಿಲ್ಲದೆ ಸರಾಗವಾಗಿ ಚಲಿಸಲು ಇದು ಸಹಕಾರಿ.'
        },
        touchGo: {
          heading: 'ಟಚ್-ಅಂಡ್-ಗೋ ಕಾರ್ಡ್‌ಗಳು',
          content: 'ದಿನನಿತ್ಯ ಓಡಾಡುವವರಿಗಾಗಿ, ಸ್ಮಾರ್ಟ್ ಕಾರ್ಡ್ ಬಳಸಿ ತ್ವರಿತವಾಗಿ ಟೋಲ್ ಪಾವತಿಸುವ ವ್ಯವಸ್ಥೆ ಇಲ್ಲಿದೆ. ಕಾರ್ಡ್ ಅನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ ಕ್ಷಣಾರ್ಧದಲ್ಲಿ ಮುಂದುವರಿಯಬಹುದು.',
          readMoreContent: 'ಇದರಿಂದ ಚಿಲ್ಲರೆಗಾಗಿ ಪರದಾಡುವುದು ತಪ್ಪುತ್ತದೆ ಮತ್ತು ದಿನನಿತ್ಯದ ಪ್ರಯಾಣ ಸುಗಮವಾಗುತ್ತದೆ. ಇದು ಡಿಜಿಟಲ್ ಪಾವತಿ ವ್ಯವಸ್ಥೆಯೊಂದಿಗೆ ಜೋಡಣೆಯಾಗಿರುವುದರಿಂದ ಬಳಸಲು ಅತ್ಯಂತ ಸುಲಭ.'
        },
        manual: {
          heading: 'ಮ್ಯಾನುಯಲ್ ಕೌಂಟರ್‌ಗಳು',
          content: 'ಫಾಸ್ಟ್ಯಾಗ್ ಇಲ್ಲದ ವಾಹನಗಳಿಗೆ ಮತ್ತು ಏನಾದರೂ ತಾಂತ್ರಿಕ ದೋಷವಾದಾಗ ಬಳಸಲು ಕೆಲವು ಮ್ಯಾನುಯಲ್ ಬೂತ್‌ಗಳನ್ನು ಉಳಿಸಿಕೊಳ್ಳಲಾಗಿದೆ.',
          readMoreContent: 'ಸುಂಕ ವಸೂಲಾತಿ ಕೇಂದ್ರದಲ್ಲಿ ಸಂಚಾರ ದಟ್ಟಣೆ ಆಗದಂತೆ ನೋಡಿಕೊಳ್ಳುವುದು ಮತ್ತು ನಗದು ಪಾವತಿಸುವವರಿಗೂ ಅವಕಾಶ ನೀಡುವುದು ಇದರ ಉದ್ದೇಶ. ಯಾವುದೇ ಸಂದರ್ಭದಲ್ಲೂ ವಾಹನ ಸಂಚಾರ ನಿಲ್ಲದಂತೆ ಈ ಕೌಂಟರ್‌ಗಳು ನೋಡಿಕೊಳ್ಳುತ್ತದೆ.'
        },
        tmc: {
          heading: 'ಕೇಂದ್ರೀಕೃತ ಟೋಲ್ ಕಂಟ್ರೋಲ್ ರೂಮ್ (TMC)',
          content: 'ಎಲ್ಲಾ ಟೋಲ್ ಗೇಟ್‌ಗಳ ಮೇಲೆ ನಿಗಾ ಇಡಲು ಒಂದು ಮುಖ್ಯ ಕಂಟ್ರೋಲ್ ರೂಮ್ ಇರುತ್ತದೆ. ಇಲ್ಲಿ ಟ್ರಾಫಿಕ್ ಮತ್ತು ಹಣಕಾಸಿನ ವಹಿವಾಟನ್ನು ಲೈವ್ ಆಗಿ (Real-time) ವೀಕ್ಷಿಸಬಹುದು.',
          readMoreContent: 'ಇದು 24/7 ಕೆಲಸದ ಮೇಲೆ ನಿಗಾ ಇಡುವುದರಿಂದ, ರಸ್ತೆಯಲ್ಲಿ ಏನಾದರೂ ತೊಂದರೆಯಾದರೆ ತಕ್ಷಣ ಸಹಾಯಕ್ಕೆ ಧಾವಿಸಲು ಸಾಧ್ಯವಾಗುತ್ತದೆ. ಸುಂಕ ವಸೂಲಾತಿಯಲ್ಲಿ ಪಾರದರ್ಶಕತೆ ಕಾಯ್ದುಕೊಳ್ಳಲು ಮತ್ತು ಸಂಗ್ರಹವಾದ ಮಾಹಿತಿಯನ್ನು ಬಳಸಿ ರಸ್ತೆಯನ್ನು ಇನ್ನಷ್ಟು ಸುಧಾರಿಸಲು ಇದು ಸಹಕಾರಿಯಾಗಿದೆ.'
        },
        mainlinePlazas: {
          heading: 'ಮುಖ್ಯ ಟೋಲ್ ಪ್ಲಾಜಾಗಳು',
          content: 'ಈ ರಸ್ತೆಯ ಆರಂಭ ಮತ್ತು ಅಂತ್ಯದಲ್ಲಿ ಮುಖ್ಯ ಟೋಲ್ ಪ್ಲಾಜಾಗಳಿದ್ದು, ಇವು ನೈಸ್ (NICE) ರಸ್ತೆಗೆ ನೇರ ಸಂಪರ್ಕ ಕಲ್ಪಿಸುತ್ತವೆ. ಇದರಿಂದ ವಾಹನಗಳು ಯಾವುದೇ ಅಡಚಣೆಯಿಲ್ಲದೆ ಒಂದು ರಸ್ತೆಯಿಂದ ಇನ್ನೊಂದಕ್ಕೆ ಸಾಗಬಹುದು.',
          readMoreContent: 'ಈ ವ್ಯವಸ್ಥೆಯಿಂದಾಗಿ ವಾಹನಗಳು ಮಧ್ಯೆ ಎಲ್ಲಿಯೂ ಪದೇ ಪದೇ ನಿಲ್ಲುವ ಅಗತ್ಯವಿರುವುದಿಲ್ಲ. ದೂರದ ಊರುಗಳಿಗೆ ಹೋಗುವವರಿಗೆ ಮತ್ತು ಸಿಟಿ ಬಿಟ್ಟು ಹೊರ ಹೋಗುವ ವಾಹನಗಳಿಗೆ ಇದು ಸಮಯ ಉಳಿಸಲು ಮತ್ತು ಸಂಚಾರ ದಟ್ಟಣೆ ತಪ್ಪಿಸಲು ಮಾಡಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ.'
        },
        entryExitPlazas: {
          heading: 'ಪ್ರವೇಶ ಮತ್ತು ನಿರ್ಗಮನ ದ್ವಾರಗಳು',
          content: 'ಪ್ರಮುಖ 8 ಕಡೆಗಳಲ್ಲಿ ರಸ್ತೆಗೆ ಪ್ರವೇಶಿಸಲು ಮತ್ತು ಹೊರಹೋಗಲು ಪ್ರತ್ಯೇಕ ಟೋಲ್ ಗೇಟ್‌ಗಳಿವೆ. ಇಲ್ಲಿ ನೀವು ಎಷ್ಟು ದೂರ ಪ್ರಯಾಣಿಸುತ್ತೀರೋ ಅಷ್ಟಕ್ಕೆ ಮಾತ್ರ ಹಣ ಪಾವತಿಸುವ ವ್ಯವಸ್ಥೆಯಿದೆ.',
          readMoreContent: 'ಇಡೀ ರಸ್ತೆಗೆ ಹಣ ಕೊಡುವ ಬದಲು, ನೀವು ಬಳಸುವ ಭಾಗಕ್ಕೆ ಮಾತ್ರ ಹಣ ಕೊಡುವುದರಿಂದ ಇದು ಹೆಚ್ಚು ನ್ಯಾಯಯುತವಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸಲಿದೆ. ಪ್ರಯಾಣಿಕರಿಗೆ ಅನುಕೂಲಕರವಾಗಿರುವ ವ್ಯವಸ್ಥೆಯಾಗಿರಲಿದ್ದು, ಟೋಲ್ ಸಂಗ್ರಹಣೆ ಮತ್ತು ಟ್ರಾಫಿಕ್ ನಿರ್ವಹಣೆಯನ್ನು ಅಚ್ಚುಕಟ್ಟಾಗಿ ಮಾಡಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ.'
        }
      },
      footer: '<strong>ಪ್ರಯಾಣಿಕರ ಸಮಯ ಉಳಿತಾಯ ಮತ್ತು ಅನುಕೂಲಕ್ಕಾಗಿ ಈ ಟೋಲ್ ವ್ಯವಸ್ಥೆಯನ್ನು ರೂಪಿಸಲಾಗಿದೆ. ಇದರಿಂದ ಪ್ರಯಾಣವು ಯಾವುದೇ ಅಡೆತಡೆಯಿಲ್ಲದೆ ಸಾಗುವುದು ಖಚಿತ.</strong>'
    },

    // ITS
    its: {
      title: 'ಇಂಟೆಲಿಜೆಂಟ್ ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ ಸಿಸ್ಟಮ್ಸ್ (ITS)',
      subtitle: 'ಸುರಕ್ಷಿತ ಪ್ರಯಾಣಕ್ಕೆ ಸ್ಮಾರ್ಟ್ ತಂತ್ರಜ್ಞಾನ',
      description: 'ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್‌ ಕಾರಿಡಾರ್ ಒಂದು ಸ್ಮಾರ್ಟ್ ಹೈವೇ ಆಗಿದ್ದು, ಇಲ್ಲಿ ಅತ್ಯಾಧುನಿಕ ತಂತ್ರಜ್ಞಾನದ ಮೂಲಕ ರಸ್ತೆಯ ಮೇಲೆ 24/7 ನಿಗಾ ಇಡಲಾಗುತ್ತದೆ.',
      descriptionReadMore: 'ಮಳೆ, ಚಳಿ ಅಥವಾ ಎಷ್ಟೇ ಟ್ರಾಫಿಕ್ ಇದ್ದರೂ ರಸ್ತೆಯ ಸ್ಥಿತಿಗತಿಯನ್ನು ಈ ತಂತ್ರಜ್ಞಾನ ತಕ್ಷಣವೇ ಗ್ರಹಿಸುತ್ತದೆ. ಎಲ್ಲಾದರೂ ಅಪಘಾತವಾದರೆ ತಕ್ಷಣವೇ ಸಹಾಯ ಒದಗಿಸಲು ಮತ್ತು ಟ್ರಾಫಿಕ್ ಜಾಮ್ ಆಗದಂತೆ ನೋಡಿಕೊಳ್ಳಲು ಇದು ಸಹಕಾರಿಯಾಗಿದೆ. ಇದರಿಂದ ನಿಮ್ಮ ಪ್ರಯಾಣ ಸುಗಮ ಮತ್ತು ಸುರಕ್ಷಿತವಾಗಿರುತ್ತದೆ.',
      systems: {
        cctv: {
          heading: 'ಸ್ಮಾರ್ಟ್ ಸಿಸಿಟಿವಿ ಕಣ್ಗಾವಲು',
          content: 'ಇಲ್ಲಿರುವ ಅತ್ಯಾಧುನಿಕ ಕ್ಯಾಮೆರಾಗಳು ಕೇವಲ ವಿಡಿಯೋ ರೆಕಾರ್ಡ್ ಮಾಡುವುದಿಲ್ಲ, ಬದಲಿಗೆ ರಸ್ತೆಯಲ್ಲಿ ಅಪಘಾತವಾದರೆ ಅಥವಾ ವಾಹನ ಕೆಟ್ಟು ನಿಂತರೆ ತಕ್ಷಣವೇ ಕಂಟ್ರೋಲ್ ರೂಂಗೆ ಸಂದೇಶ ಕಳಿಸುತ್ತವೆ.',
          readMoreContent: 'ಇದರಿಂದ ಪೊಲೀಸ್ ಮತ್ತು ಆಂಬುಲೆನ್ಸ್ ತಂಡಗಳಿಗೆ ತಕ್ಷಣ ವಿಷಯ ತಿಳಿಯುತ್ತದೆ. ಪರಿಣಾಮವಾಗಿ, ಯಾವುದೇ ವಿಳಂಬವಿಲ್ಲದೇ ಸಹಾಯವು ಪ್ರಯಾಣಿಕರಿಗೆ ದೊರೆಯುತ್ತದೆ.'
        },
        atcc: {
          heading: 'ಸ್ವಯಂಚಾಲಿತ ಟ್ರಾಫಿಕ್ ಕೌಂಟರ್‌ಗಳು (ATCC)',
          content: 'ಈ ವ್ಯವಸ್ಥೆಯು ರಸ್ತೆಯಲ್ಲಿ ಎಷ್ಟು ವಾಹನಗಳು ಓಡಾಡುತ್ತಿವೆ ಮತ್ತು ಅವು ಯಾವ ರೀತಿಯ ವಾಹನಗಳು ಎಂಬುದನ್ನು ನಿರಂತರವಾಗಿ ಲೆಕ್ಕ ಹಾಕುತ್ತದೆ.',
          readMoreContent: 'ಈ ಮಾಹಿತಿಯು ಟ್ರಾಫಿಕ್ ಜಾಮ್ ತಡೆಯಲು ಮತ್ತು ರಸ್ತೆಯನ್ನು ಉತ್ತಮವಾಗಿ ನಿರ್ವಹಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ. ಅಲ್ಲದೆ, ಭವಿಷ್ಯದಲ್ಲಿ ಟ್ರಾಫಿಕ್ ಎಷ್ಟಾಗಬಹುದು ಎಂದು ಅಂದಾಜಿಸಲು ಮತ್ತು ಅದಕ್ಕೆ ತಕ್ಕಂತೆ ಯೋಜನೆ ರೂಪಿಸಲು ಈ ಅಂಕಿ-ಅಂಶಗಳು  ಸಹಕಾರಿಯಾಗಲಿವೆ.'
        },
        vvd: {
          heading: 'ವೀಡಿಯೊ ಆಧಾರಿತ ವಾಹನ ಪತ್ತೆ (VVD)',
          content: 'ಹಳೆಯ ವ್ಯವಸ್ಥೆಯಾದ ರಸ್ತೆಯ ಒಳಗೆ ವೈರ್ (Loop) ಹಾಕುವ ಬದಲು, ವಿವಿಡಿ ಎಂಬ ಹೊಸ ಕ್ಯಾಮೆರಾ ವ್ಯವಸ್ಥೆಯನ್ನು ಬಳಸಲಾಗುತ್ತಿದೆ. ಇದರಿಂದ ವಾಹನಗಳನ್ನು ಪತ್ತೆ ಹಚ್ಚಲು ರಸ್ತೆ ಅಗೆಯುವ ಪ್ರಮೇಯ ಬರುವುದಿಲ್ಲ.',
          readMoreContent: 'ರಸ್ತೆ ಹಾಳಾಗುವುದಿಲ್ಲವಾದ್ದರಿಂದ ಪದೇ ಪದೇ ರಿಪೇರಿ ಮಾಡುವ ಅಗತ್ಯವಿರುವುದಿಲ್ಲ. ಯಾವುದೇ ತೊಂದರೆಯಿಲ್ಲದೆ ಈ ವ್ಯವಸ್ಥೆ ನಿಖರವಾಗಿ ಕೆಲಸ ಮಾಡುತ್ತದೆ.'
        },
        vms: {
          heading: 'ವೇರಿಯಬಲ್ ಮೆಸೇಜ್ ಸೈನ್ಸ್ (VMS)',
          content: 'ರಸ್ತೆಯ ಆಯಕಟ್ಟಿನ ಸ್ಥಳಗಳಲ್ಲಿ ಅಳವಡಿಸಲಾದ \'ವೇರಿಯಬಲ್ ಮೆಸೇಜ್ ಸೈನ್ಸ್\' (VMS) ಫಲಕಗಳು, ಸಂಚಾರ ದಟ್ಟಣೆ, ಹವಾಮಾನ ಮುನ್ನೆಚ್ಚರಿಕೆ ಮತ್ತು ಅನಿರೀಕ್ಷಿತ ಘಟನೆಗಳ ಕುರಿತು ಕ್ಲಪ್ತ ಸಮಯದಲ್ಲಿ ಮಾಹಿತಿಯನ್ನು ಬಿತ್ತರಿಸುತ್ತವೆ.',
          readMoreContent: 'ಈ ಮಾಹಿತಿಯು ಚಾಲಕರಿಗೆ ತಮ್ಮ ಪ್ರಯಾಣದ ಮಾರ್ಗವನ್ನು ಬದಲಿಸಲು ಅಥವಾ ಮುನ್ನೆಚ್ಚರಿಕೆ ವಹಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ. ಪ್ರಯಾಣದ ಆರಂಭದಲ್ಲಿ ಮತ್ತು ಪ್ರಯಾಣದ ಸಮಯದಲ್ಲಿ ಸೂಕ್ತ ನಿರ್ಧಾರಗಳನ್ನು ಕೈಗೊಳ್ಳಲು ಇದು ಅತ್ಯಗತ್ಯವಾಗಿದೆ.'
        },
        ofc: {
          heading: 'ಆಪ್ಟಿಕಲ್ ಫೈಬರ್ ಸಂಪರ್ಕ',
          content: 'ರಸ್ತೆಯ ಸಿಸಿಟಿವಿಗಳು, ಸೆನ್ಸಾರ್‌ಗಳು ಮತ್ತು ಟೋಲ್ ಗೇಟ್‌ಗಳನ್ನು ಕೇಂದ್ರ ಕಂಟ್ರೋಲ್ ರೂಮ್‌ಗೆ ಸಂಪರ್ಕಿಸಲು ಪ್ರತ್ಯೇಕವಾದ ಆಪ್ಟಿಕಲ್ ಫೈಬರ್ ಕೇಬಲ್ ಅಳವಡಿಸಲಾಗಿದೆ.',
          readMoreContent: 'ಇಂಟರ್ನೆಟ್ ವೇಗವನ್ನು ವರ್ಧಿಸುವುದಲ್ಲದೇ, ಈ ಕೇಬಲ್ ಮೂಲಕ ಮಾಹಿತಿ ಕ್ಷಣಾರ್ಧದಲ್ಲಿ ರವಾನೆಯಾಗುತ್ತದೆ. ಇದರಿಂದ ಇಡೀ ರಸ್ತೆಯ ವ್ಯವಸ್ಥೆಯನ್ನು ಒಂದೇ ಕಡೆಯಿಂದ ಸುಲಭವಾಗಿ ನಿಯಂತ್ರಿಸಲು ಸಾಧ್ಯವಾಗುತ್ತದೆ.'
        }
      }
    },

    // Environment
    environment: {
      title: 'ಸುಸ್ಥಿರ ಅಭಿವೃದ್ಧಿ ಯೋಜನೆ',
      subtitle: 'ಬೆಂಗಳೂರಿನ ಭವಿಷ್ಯದ ದೃಷ್ಟಿಯಿಂದ ಜವಾಬ್ದಾರಿಯುತ ಯೋಜನೆ',
      description: 'ಈ ಕಾರಿಡಾರ್ ನಿರ್ಮಿಸುವಾಗ ಪರಿಸರ ಮತ್ತು ಜನರ ಹಿತಕ್ಕೆ ಮೊದಲ ಆದ್ಯತೆ ನೀಡಲಾಗಿದೆ. ಈ ಅಭಿವೃದ್ಧಿಯಿಂದ ಪರಿಸರಕ್ಕಾಗಲಿ ಅಥವಾ ಜನರಿಗಾಗಲಿ ತೊಂದರೆಯಾಗದಂತೆ ಎಚ್ಚರವಹಿಸಲಾಗಿದೆ.',
      descriptionReadMore: 'ಯೋಜನೆಗೆ ಸುಮಾರು 2,557 ಎಕರೆ ಭೂಮಿ ಅಗತ್ಯವಿದ್ದು, ಭೂಮಿ ನೀಡುವವರಿಗೆ ಸರಿಯಾದ ಪುನರ್ವಸತಿ ಮತ್ತು ಪರಿಹಾರ ಒದಗಿಸಲು ಸಮೀಕ್ಷೆ ನಡೆಸಲಾಗಿದೆ. ಪರಿಸರಕ್ಕೆ ಹಾನಿಯಾಗದಂತೆ ಮತ್ತು ಸಾಮಾಜಿಕ ಜವಾಬ್ದಾರಿಯನ್ನು ಮನದಲ್ಲಿಟ್ಟುಕೊಂಡು ಈ ಯೋಜನೆಯನ್ನು ಕೈಗೆತ್ತಿಕೊಳ್ಳಲಾಗಿದೆ.',
      initiatives: {
        greenBuffers: {
          heading: 'ಹಸಿರು ಹೊದಿಕೆ',
          content: 'ರಸ್ತೆಯ ಇಕ್ಕೆಲಗಳಲ್ಲಿ ಸಾಲಾಗಿ ಮರ-ಗಿಡಗಳನ್ನು ಬೆಳೆಸಿ, ಹಸಿರು ವಲಯವನ್ನು ನಿರ್ಮಿಸಲಾಗುವುದು.',
          readMoreContent: 'ಇವು ಪರಿಸರ ಸಂರಕ್ಷಣೆಯ ನಿಟ್ಟಿನಲ್ಲಿ ಮಹತ್ವದ ಹೆಜ್ಜೆಯಾಗಿರಲಿದೆ. ವಾಹನಗಳಿಂದ ಹೊರಸೂಸುವ ಧೂಳು, ಶಬ್ದ ಮತ್ತು ವಾತಾವರಣದಲ್ಲಿರುವ ಬಿಸಿಲ ಧಗೆಯನ್ನು ಕಡಿಮೆ ಮಾಡಲು ಇವು ಸಹಾಯ ಮಾಡುತ್ತವೆ. ಇದರಿಂದ ಅಕ್ಕಪಕ್ಕದ ಪ್ರದೇಶಗಳಲ್ಲಿ ಉತ್ತಮ ವಾತಾವರಣ ನಿರ್ಮಾಣವಾಗುತ್ತದೆ.'
        },
        lakeRejuvenation: {
          heading: 'ಕೆರೆಗಳ ಪುನರುಜ್ಜೀವನ',
          content: 'ಪರಿಸರವನ್ನು ಸಂರಕ್ಷಣೆಯ ಹಿತದೃಷ್ಟಿಯಿಂದ, ಈ ರಸ್ತೆ ಹಾದುಹೋಗುವ ಮಾರ್ಗದಲ್ಲಿರುವ 7 ಕೆರೆಗಳಿಗೆ ಹೊಸ ರೂಪ ನೀಡಲಾಗುತ್ತಿದೆ. ಕೆರೆ ಹೂಳೆತ್ತಿ, ಏರಿಗಳನ್ನು ಭದ್ರಪಡಿಸಿ, ದಡಗಳಿಗೆ ಕಲ್ಲು ಕಟ್ಟಿ, ಸುತ್ತಲೂ ನಡೆಯಲು ಕಾಲ್ನಡಿಗೆಯ ದಾರಿಯನ್ನು ನಿರ್ಮಿಸಲಾಗುವುದು.',
          readMoreContent: 'ಇದರಿಂದ ಕೆರೆಯಲ್ಲಿ ಹೆಚ್ಚು ನೀರು ನಿಲ್ಲಲು ಸಾಧ್ಯವಾಗುತ್ತದೆ ಮತ್ತು ಪ್ರಕೃತಿಯ ಸಮತೋಲನ ಕಾಪಾಡಲು ಸಹಾಯವಾಗುತ್ತದೆ.'
        },
        serviceAreas: {
          heading: 'ವಿಶ್ರಾಂತಿ ಮತ್ತು ಸೇವಾ ತಾಣಗಳು',
          content: 'ಪ್ರಯಾಣಿಕರ ಅನುಕೂಲಕ್ಕಾಗಿ ರಸ್ತೆಯ ಆಯ್ದ ಭಾಗಗಳಲ್ಲಿ ಪೆಟ್ರೋಲ್ ಬಂಕ್, ಹೋಟೆಲ್ ಮತ್ತು ವಿಶ್ರಾಂತಿ ಗೃಹಗಳಂತಹ ಸೌಲಭ್ಯಗಳನ್ನು ಕಲ್ಪಿಸಲಾಗುವುದು.',
          readMoreContent: 'ಹೆದ್ದಾರಿಯ ಸಂಚಾರಕ್ಕೆ ತೊಂದರೆಯಾಗದಂತೆ ರಸ್ತೆಯಿಂದ ಸ್ವಲ್ಪ ಪಕ್ಕಕ್ಕೆ ಇವುಗಳನ್ನು ನಿರ್ಮಿಸಲಾಗುತ್ತದೆ. ದೂರದ ಊರಿಗೆ ಹೋಗುವವರು ಇಲ್ಲಿ ವಿಶ್ರಾಂತಿ ಪಡೆದು, ಫ್ರೆಶ್ ಆಗಿ ಮುಂದೆ ಸಾಗಲು ಇದು ಸಹಕಾರಿಯಾಗಿದೆ.'
        },
        publicTransport: {
          heading: 'ಸಾರ್ವಜನಿಕ ಸಾರಿಗೆ ಸಂಪರ್ಕ',
          content: 'ಬಸ್ಸುಗಳ ಸುಗಮ ಸಂಚಾರಕ್ಕಾಗಿ ಮತ್ತು ಪ್ರಯಾಣಿಕರ ಅನುಕೂಲಕ್ಕಾಗಿ ಸರ್ವಿಸ್ ರಸ್ತೆಗಳಲ್ಲಿ ಬಸ್ ನಿಲ್ದಾಣಗಳನ್ನು ನಿರ್ಮಿಸಲಾಗಿದೆ.',
          readMoreContent: 'ಇದು ವಿವಿಧ ರೀತಿಯ ವಾಹನ ಬದಲಾವಣೆ (Multimodal) ಮಾಡಿಕೊಂಡು ಪ್ರಯಾಣಿಸುವವರಿಗೆ ಸಹಕಾರಿ. ಮುಖ್ಯವಾಗಿ, ಅಕ್ಕಪಕ್ಕದ ಬಡಾವಣೆಗಳ ಜನರು ಮುಖ್ಯ ರಸ್ತೆಗೆ ಬಂದು ಬಸ್ ಹತ್ತಲು ಇದು ಅನುಕೂಲಕರವಾಗಿದೆ.'
        },
        sustainableLighting: {
          heading: 'ಪರಿಸರ ಸ್ನೇಹಿ ಬೆಳಕಿನ ವ್ಯವಸ್ಥೆ',
          content: 'ಪರಿಸರಕ್ಕೆ ಹಾನಿಯಾಗದಂತೆ, ಸೌರಶಕ್ತಿಯಿಂದ (Solar) ಕೆಲಸ ಮಾಡುವ ದೀಪಗಳನ್ನು ಇಲ್ಲಿ ಬಳಸಲಾಗಿದೆ. ಇದು ವಿದ್ಯುತ್ ಉಳಿತಾಯದ ಜೊತೆಗೆ ಪರಿಸರ ಮಾಲಿನ್ಯವನ್ನು (Carbon footprint) ಕಡಿಮೆ ಮಾಡುತ್ತದೆ.',
          readMoreContent: 'ರಾತ್ರಿ ವೇಳೆ ಯಾವುದೇ ಅಡಚಣೆಯಿಲ್ಲದೆ ದೀಪಗಳು ಉರಿಯುವುದರಿಂದ, ವಾಹನ ಸವಾರರಿಗೆ ಸುರಕ್ಷಿತ ಮತ್ತು ಸ್ಥಿರವಾದ ಬೆಳಕು ಸಿಗುವುದು ಖಚಿತ.'
        },
        waterfront: {
          heading: 'ಕೆರೆ ದಂಡೆಗಳ ಅಭಿವೃದ್ಧಿ',
          content: 'ಕೆರೆಗಳನ್ನು ಉಳಿಸಿಕೊಳ್ಳುವ ಜೊತೆಗೆ ಅವುಗಳನ್ನು ಸೌಂದರ್ಯೀಕರಣಗೊಳಿಸಲು ಎಚ್ಚರಿಕೆಯಿಂದ ಈ ಯೋಜನೆ ರೂಪಿಸಲಾಗಿದೆ.',
          readMoreContent: 'ಕೆರೆಯ ನೈಸರ್ಗಿಕ ಪರಿಸರಕ್ಕೆ ತೊಂದರೆಯಾಗದಂತೆ, ಜನರು ಅಲ್ಲಿಗೆ ಹೋಗಿ ಬರಲು ಮತ್ತು ಪ್ರಕೃತಿಯನ್ನು ಆಸ್ವಾದಿಸಲು ಸುಂದರವಾದ ವಾತಾವರಣವನ್ನು ನಿರ್ಮಿಸುವುದು ಇದರ ಉದ್ದೇಶ.'
        }
      },
      lakeSustainability: {
        heading: 'ಕೆರೆಗಳ ಅಭಿವೃದ್ಧಿ ಯೋಜನೆ',
        content: 'ಪಿಆರ್‌ಆರ್ ರಸ್ತೆ ಹಾದುಹೋಗುವ ಮಾರ್ಗದಲ್ಲಿ ಸಿಗುವ 7 ಕೆರೆಗಳನ್ನು ಉಳಿಸಲು ವಿಶೇಷ ಕಾಳಜಿ ವಹಿಸಲಾಗಿದೆ. ಕೆರೆಗಳ ಹೂಳು ತೆಗೆದು, ಅವು ಹೆಚ್ಚು ನೀರು ಹಿಡಿದಿಟ್ಟುಕೊಳ್ಳುವಂತೆ ಮಾಡಲಾಗುವುದು.',
        readMoreContent: 'ಕೆರೆ ಏರಿಗಳು ಕುಸಿಯದಂತೆ ಕಲ್ಲು ಜೋಡಿಸುವುದು ಮತ್ತು ಸುತ್ತಲೂ ನಡೆಯಲು ದಾರಿ ಮಾಡಿಕೊಡುವ ಮೂಲಕ ಕೆರೆಗಳಿಗೆ ಹೊಸ ರೂಪ ನೀಡಲಾಗುವುದು. ಕೆರೆಯ ಜಾಗವನ್ನು ಒತ್ತುವರಿ ಮಾಡದೆ ಅಥವಾ ವ್ಯಾಪ್ತಿಯನ್ನು ಕಡಿಮೆ ಮಾಡದೆ, ಅವುಗಳನ್ನು ಸುಂದರವಾದ ತಾಣಗಳಾಗಿ ಅಭಿವೃದ್ಧಿಪಡಿಸುವುದು ಇದರ ಉದ್ದೇಶ.'
      },
      stats: {
        land: '2,557 ಎಕರೆ',
        landLabel: 'ಒಟ್ಟು ಭೂಮಿ ಅಗತ್ಯ',
        lakes: '7 ಕೆರೆಗಳು',
        lakesLabel: 'ಪುನರುಜ್ಜೀವನಗೊಳಿಸಲು',
        green: '100% ಹಸಿರು',
        greenLabel: 'ಸಂಪೂರ್ಣ ಸೌರ ಬೆಳಕು'
      }
    },

    // Delivery & Cost
    delivery: {
      title: 'ವೆಚ್ಚ ಮತ್ತು ಕಾಲಮಿತಿ',
      subtitle: 'ಯೋಜನೆಯ ಅನುಷ್ಠಾನ ಮತ್ತು ಬಂಡವಾಳ ಹೂಡಿಕೆ',
      description: 'ಬೆಂಗಳೂರಿನ ಭವಿಷ್ಯಕ್ಕಾಗಿ ದೊಡ್ಡ ಹೂಡಿಕೆ\n\nಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್‌ ಕಾರಿಡಾರ್ ಕರ್ನಾಟಕದ ಅತಿದೊಡ್ಡ ರಸ್ತೆ ಮೂಲಸೌಕರ್ಯಗಳ ಯೋಜನೆಗಳಲ್ಲಿ ಒಂದಾಗಿದೆ. ಈ ಯೋಜನೆಯ ವ್ಯಾಪ್ತಿ ಮತ್ತು ಭವಿಷ್ಯದಲ್ಲಿ ಇದರಿಂದಾಗುವ ಆರ್ಥಿಕ ಲಾಭಗಳು ಇದರ ಮಹತ್ವವನ್ನು ಸಾರುತ್ತವೆ.',
      descriptionReadMore: 'ಈ ಯೋಜನೆಯಲ್ಲಿ ಹೂಡಿಕೆ ಮಾಡಲಾದ ಹಣವನ್ನು ಕೇವಲ ರಸ್ತೆ ನಿರ್ಮಾಣಕ್ಕೆ ಮಾತ್ರವಲ್ಲದೆ, ಭೂಸ್ವಾಧೀನ, ಜನರ ಹಿತರಕ್ಷಣೆ ಮತ್ತು ಪರಿಸರವನ್ನು ಕಾಪಾಡಲು ಸಮಾನವಾಗಿ ಹಂಚಿಕೆ ಮಾಡಲಾಗಿದೆ. ಯೋಜನೆಯು ಯಾವುದೇ ತೊಂದರೆಯಿಲ್ಲದೆ ಪೂರ್ಣಗೊಳ್ಳುವುದನ್ನು ಇದು ಖಚಿತಪಡಿಸುತ್ತದೆ.',
      totalInvestment: {
        // heading: 'ಒಟ್ಟು ಹೂಡಿಕೆ: ಅಂದಾಜು ₹27,000 ಕೋಟಿ',
        content: 'ಈ ಯೋಜನೆಯು ಅಂದಾಜು ₹27,000  ಕೋಟಿ ಹೂಡಿಕೆಯನ್ನು ಒಳಗೊಂಡಿದೆ.',
        readMoreContent: 'ರಾಜ್ಯದ ಇತಿಹಾಸದಲ್ಲಿ ಅತ್ಯಂತ ಮಹತ್ವದ ಸಾರಿಗೆ ಮೂಲಸೌಕರ್ಯ ಉಪಕ್ರಮಗಳಲ್ಲಿ ಒಂದಾಗಿ ಇದು ಸ್ಥಾನ ಪಡೆದಿದೆ.'
      },
      costItems: {
        civilWorks: {
          heading: 'ಸಿವಿಲ್ ಕಾಮಗಾರಿಗಳು',
          content: 'ಸಿವಿಲ್ ಕಾಮಗಾರಿಗಳಿಗೆ  ₹7,000 – 8,000 ಕೋಟಿ ಮೀಸಲಿಡಲಾಗಿದೆ.',
          contentFull: 'ಸಿವಿಲ್ ಕಾಮಗಾರಿಗಳಿಗೆ  ₹7,000 – 8,000 ಕೋಟಿ ಮೀಸಲಿಡಲಾಗಿದೆ.',
          readMoreContent: 'ಇದು ಹೆದ್ದಾರಿ ನಿರ್ಮಾಣ, ರಚನೆಗಳು, ಸರ್ವಿಸ್‌ ರಸ್ತೆಗಳು, ಇಂಟರ್‌ಚೇಂಜ್‌ಗಳು, ಸೇತುವೆಗಳು ಮತ್ತು ಸಂಬಂಧಿತ ಕಾರಿಡಾರ್ ಮೂಲಸೌಕರ್ಯಗಳನ್ನು ಒಳಗೊಂಡಿದೆ.'
        },
        landAcquisition: {
          heading: 'ಭೂಸ್ವಾಧೀನ',
          content: 'ಗಮನಾರ್ಹವಾದ ₹20,511 ಕೋಟಿಯನ್ನು ಭೂಸ್ವಾಧೀನಕ್ಕೆ ಮೀಸಲಿಡಲಾಗಿದೆ.',
          contentFull: 'ಗಮನಾರ್ಹವಾದ ₹20,511 ಕೋಟಿಯನ್ನು ಭೂಸ್ವಾಧೀನಕ್ಕೆ ಮೀಸಲಿಡಲಾಗಿದೆ.',
          readMoreContent: 'ಇದು ಕಾರಿಡಾರ್‌ನ ವ್ಯಾಪ್ತಿ ಮತ್ತು ಯೋಜಿತ ಹಾಗೂ ಕಾನೂನುಬದ್ಧ ರೀತಿಯಲ್ಲಿ ಭೂಮಿಯನ್ನು ಸ್ವಾಧೀನಪಡಿಸಿಕೊಳ್ಳುವ ಬದ್ಧತೆಯನ್ನು ಪ್ರತಿಬಿಂಬಿಸುತ್ತದೆ.'
        },
        rnr: {
          heading: 'ಪುನರ್ವಸತಿ ಮತ್ತು ಪರಿಹಾರ',
          content: 'ಪುನರ್ವಸತಿ ಮತ್ತು ಪರಿಹಾರಕ್ಕಾಗಿ (R&R) ಅಂದಾಜು  ₹750 ಕೋಟಿ ಮೀಸಲಿಡಲಾಗಿದೆ.',
          contentFull: 'ಪುನರ್ವಸತಿ ಮತ್ತು ಪರಿಹಾರಕ್ಕಾಗಿ (R&R) ಅಂದಾಜು  ₹750 ಕೋಟಿ ಮೀಸಲಿಡಲಾಗಿದೆ.',
          readMoreContent: ' ಭೂಮಿ ಕಳೆದುಕೊಂಡವರಿಗೆ ನ್ಯಾಯಯುತ ಪರಿಹಾರ, ರಚನಾತ್ಮಕ ಸ್ಥಳಾಂತರ ಮತ್ತು ಜೀವನೋಪಾಯಕ್ಕೆ ನೆರವನ್ನು ಇದು ಖಚಿತಪಡಿಸುತ್ತದೆ.'
        },
        environmental: {
          heading: 'ಪರಿಸರ ಸಂರಕ್ಷಣೆಗಾಗಿ',
          content: 'ಪರಿಸರಕ್ಕೆ ಹಾನಿಯಾಗದಂತೆ ನೋಡಿಕೊಳ್ಳಲು ಮತ್ತು ಅಭಿವೃದ್ಧಿ ಕಾರ್ಯಗಳಿಗಾಗಿ ಸುಮಾರು ₹65 ಕೋಟಿ ಹಣವನ್ನು ಎತ್ತಿಡಲಾಗಿದೆ.',
          contentFull: 'ಪರಿಸರಕ್ಕೆ ಹಾನಿಯಾಗದಂತೆ ನೋಡಿಕೊಳ್ಳಲು ಮತ್ತು ಅಭಿವೃದ್ಧಿ ಕಾರ್ಯಗಳಿಗಾಗಿ ಸುಮಾರು ₹65 ಕೋಟಿ ಹಣವನ್ನು ಎತ್ತಿಡಲಾಗಿದೆ.',
          readMoreContent: 'ಪರಿಸರವನ್ನು ರಕ್ಷಿಸುವುದು, ಗಿಡ-ಮರಗಳನ್ನು ಮತ್ತೆ ಬೆಳೆಸುವುದು ಮತ್ತು ಸರ್ಕಾರದ ಪರಿಸರ ನಿಯಮಗಳನ್ನು ಕಟ್ಟುನಿಟ್ಟಾಗಿ ಪಾಲಿಸುವುದು ಇದರಲ್ಲಿ ಸೇರಿದೆ.'
        }
      },
      constructionTimeline: {
        heading: 'ಕಾಮಗಾರಿ ಪೂರ್ಣಗೊಳ್ಳುವ ಸಮಯ',
        content: '3 ವರ್ಷಗಳು\n\nಕೆಲಸವನ್ನು ಅಚ್ಚುಕಟ್ಟಾಗಿ ಮತ್ತು ವೇಗವಾಗಿ ನಿರ್ವಹಿಸಲು, ಈ ರಸ್ತೆಯನ್ನು ಮೂರು ಭಾಗಗಳಾಗಿ ವಿಂಗಡಿಸಲಾಗಿದೆ.',
        readMoreContent: 'ಕಾಮಗಾರಿ ಶುರುವಾದ 30 ರಿಂದ 36 ತಿಂಗಳಲ್ಲಿ (ಸುಮಾರು 3 ವರ್ಷಗಳಲ್ಲಿ) ರಸ್ತೆ ನಿರ್ಮಾಣ ಪೂರ್ಣಗೊಳ್ಳಲಿದೆ.'
      },
      smartSystems: {
        heading: 'ಸ್ಮಾರ್ಟ್ ತಂತ್ರಜ್ಞಾನ ಅಳವಡಿಕೆ',
        content: '18 ತಿಂಗಳುಗಳು\n\nಈ ರಸ್ತೆಯನ್ನು \'ಸ್ಮಾರ್ಟ್ ಹೈವೇ\' ಆಗಿ ಪರಿವರ್ತಿಸುವ ತಂತ್ರಜ್ಞಾನವನ್ನು (ITS) ಒಂದೇ ಬಾರಿಗೆ ಅಳವಡಿಸದೆ, ಹಂತ ಹಂತವಾಗಿ ಜಾರಿಗೆ ತರಲಾಗುವುದು.',
        readMoreContent: 'ವಾಹನ ಸಂಚಾರಕ್ಕೆ ತೊಂದರೆಯಾಗದಂತೆ ತಂತ್ರಜ್ಞಾನವನ್ನು ಅಳವಡಿಸುವುದು ಇದರ ಉದ್ದೇಶ. ಒಟ್ಟು 18 ತಿಂಗಳುಗಳಲ್ಲಿ ಈ ಕೆಲಸ ಪೂರ್ಣಗೊಳ್ಳಲಿದ್ದು, ರಸ್ತೆ ಸಂಪೂರ್ಣವಾಗಿ ಹೈ-ಟೆಕ್ ಆಗಿ ಬದಲಾಗಲಿದೆ.'
      },
      message: '<strong>ಇದು ಕೇವಲ ರಸ್ತೆಗಾಗಿ ಮಾಡುತ್ತಿರುವ ಖರ್ಚಲ್ಲ. ಬೆಂಗಳೂರಿನ ಆರ್ಥಿಕ ಶಕ್ತಿ, ವೇಗದ ಪ್ರಯಾಣ ಮತ್ತು ಪರಿಸರ ಸಂರಕ್ಷಣೆಗಾಗಿ ಮಾಡುತ್ತಿರುವ ಹೂಡಿಕೆ.</strong>',
      note: '* ಕಾಮಗಾರಿ ಹಂತದಲ್ಲಿ ತಗಲುವ ನೈಜ ವೆಚ್ಚವನ್ನು ಆಧರಿಸಿ, ಈ ಅಂದಾಜು ಮೊತ್ತ ಬದಲಾಗುವ ಸಾಧ್ಯತೆಯಿದೆ.'
    },

    // Contact Us Section
    contactUs: {
      title: 'ಸಂಪರ್ಕಿಸಿ',
      chairmen: {
        haris: {
          name: 'ಶ್ರೀ ಎನ್.ಎ.ಹ್ಯಾರಿಸ್',
          designation: 'ಅಧ್ಯಕ್ಷರು, ಬಿಡಿಎ'
        },
        atheeq: {
          name: 'ಶ್ರೀ ಎಲ್.ಕೆ.ಅತೀಕ್, ಐಎಎಸ್ (ನಿವೃತ್ತ)',
          designation: 'ಅಧ್ಯಕ್ಷರು, ಬಿಬಿಸಿ'
        },
        manivannan: {
          name: 'ಶ್ರೀ ಮೇಜರ್ ಮಣಿವಣ್ಣನ್ ಪಿ., ಐಎಎಸ್',
          designation: 'ಆಯುಕ್ತರು, ಬಿಡಿಎ'
        }
      },
      tableHeaders: {
        slNo: 'ಕ್ರಮ ಸಂಖ್ಯೆ',
        name: 'ಹೆಸರು',
        designation: 'ಹುದ್ದೆ',
        contact: 'ಸಂಪರ್ಕ'
      },
      contacts: [
        {
          name: 'ಜಗದೀಶ್‌ ಕೆ. ಹೆಚ್.‌, ಕೆಎಎಸ್‌',
          designation: 'ಉಪ ಆಯುಕ್ತರು (ಹೆಚ್ಚುವರಿ ಭೂಸ್ವಾಧೀನ)',
          contact: '+91 8050545425'
        },
        {
          name: 'ಶ್ರುತಿ ಎಂ. ಕೆ., ಕೆಎಎಸ್',
          designation: 'ವಿಶೇಷ ಭೂಸ್ವಾಧೀನ ಅಧಿಕಾರಿ BBC-1',
          contact: '+91 9591056238'
        },
        {
          name: 'ಪಲ್ಲವಿ ಸಾತೇನಹಳ್ಳಿ, ಕೆಎಎಸ್',
          designation: 'ವಿಶೇಷ ಭೂಸ್ವಾಧೀನ ಅಧಿಕಾರಿ BBC-2',
          contact: '+91 7019667299'
        },
        {
          name: 'ನಿಕಿತಾ ಎಂ. ಚಿನ್ನಸ್ವಾಮಿ, ಕೆಎಎಸ್',
          designation: 'ವಿಶೇಷ ಭೂಸ್ವಾಧೀನ ಅಧಿಕಾರಿ BBC-3',
          contact: '+91 9742164846'
        },
        {
          name: 'ಕಾಂತರಾಜು ಕೆ. ಜೆ., ಕೆಎಎಸ್',
          designation: 'ವಿಶೇಷ ಭೂಸ್ವಾಧೀನ ಅಧಿಕಾರಿ BBC-4',
          contact: '+91 9611002697'
        },
        {
          name: 'ಮಂಜುನಾಥ್ ಡೊಂಬರ್‌, ಕೆಎಎಸ್',
          designation: 'ವಿಶೇಷ ಭೂಸ್ವಾಧೀನ ಅಧಿಕಾರಿ BBC-5',
          contact: '+91 9880297387'
        },
        {
          name: 'ಮುಕುಂದಸ್ವಾಮಿ ಆರ್. ಜಿ., ಕೆಎಎಸ್',
          designation: 'ವಿಶೇಷ ಭೂಸ್ವಾಧೀನ ಅಧಿಕಾರಿ BBC-6',
          contact: '+91 7899507369'
        },
        {
          name: 'ಪ್ರೀತಮ್ ನಸಲಾಪುರೇ, ಕೆಎಎಸ್',
          designation: 'ವಿಶೇಷ ಭೂಸ್ವಾಧೀನ ಅಧಿಕಾರಿ BBC-7',
          contact: '+91 8762701033'
        },
        {
          name: 'ಕುನಾಲ್ ಕೆ., ಕೆಎಎಸ್',
          designation: 'ವಿಶೇಷ ಭೂಸ್ವಾಧೀನ ಅಧಿಕಾರಿ BBC-8',
          contact: '+91 8095232489'
        },
        {
          name: 'ಜಂಬಗಿ ರೇಣುಕಾಪ್ರಸಾದ್ ದಿಲೀಪ್, ಕೆಎಎಸ್',
          designation: 'ವಿಶೇಷ ಭೂಸ್ವಾಧೀನ ಅಧಿಕಾರಿ BBC-9',
          contact: '+91 9606536325'
        }
      ]
    },

  },

  english: {
    // Header & Navbar
    nav: {
      home: 'Home',
      about: 'About BBC',
      project: 'The Project',
      interchanges: '11 Interchanges of PRR-1',
      design: 'Design & Safety',
      mobility: 'Mobility & Tolling',
      its: 'ITS',
      environment: 'Environment',
      delivery: 'Delivery & Cost',
      prrProject: 'PRR Journey',
      compensation: 'Villagewise Compensation',
      contact: 'Contact Us'
    },
    header: {
      cmName: 'Shri. Siddaramaiah',
      cmTitle: 'Hon\'ble Chief Minister',
      cmTitleLine2: 'Government of Karnataka',
      dcmName: 'Shri. D. K. Shivakumar',
      dcmTitle: 'Hon\'ble Chief Minister',
      dcmTitleLine2: 'Government of Karnataka'
    },

    // Hero Section
    hero: {
      badge: 'Bengaluru Business Corridor',
      title: '',
      description: '<strong>Bengaluru Business Corridor (BBC)</strong> is a <strong>Special Purpose Vehicle (SPV)</strong> formed by the <strong>Government of Karnataka</strong> under the <strong>Bengaluru Development Authority (BDA)</strong> to implement the <strong>Peripheral Ring Road (PRR)</strong> and related infrastructure projects. Earlier known as the <strong>Bengaluru PRR Development Corporation Limited</strong>, it was renamed <strong>Bengaluru Business Corridor Limited</strong> in <strong>2024</strong>.',
      exploreButton: 'Explore the Project',
      readMore: 'Read More',
      readMoreContent: 'Bengaluru\'s rapid expansion as a technology and industrial hub has placed immense pressure on its existing road network. Chronic congestion on the Outer Ring Road and major arterial routes has led to increased travel times, reduced productivity, and declining urban mobility. The BBC project addresses this challenge by creating an excellent alternative transport framework for the city.\n\nAnchored by the PRR, the project envisions an 8-lane, access-controlled urban highway with service roads, smart tolling systems, and future-ready integration for Metro and mass transit corridors. Designed as a long-term mobility solution, the BBC will serve as a high-capacity transport backbone befitting a global city.\n\nThe PRR alignment has been strategically planned to connect all major national and state highways radiating from Bengaluru. It begins at Tumkur Road (NH-4) near Madavara, traverses the northern and eastern peripheries, and culminates at Hosur Road near Konappana Agrahara in the south, ensuring seamless inter-city and intra-city connectivity.'
    },

    // About Section
    about: {
      title: 'About BBC',
      intro: 'Bengaluru Business Corridor (BBC) is a Special Purpose Vehicle (SPV) formed by the Government of Karnataka under the Bengaluru Development Authority (BDA) to implement the Peripheral Ring Road (PRR) and related infrastructure projects. Earlier known as the Bengaluru PRR Development Corporation Limited, it was renamed Bengaluru Business Corridor Limited in 2024.',
      subtitle: 'Bengaluru Business Corridor – A Ring of Advancement Around the City',
      description1: 'Bengaluru is a city that is ever expanding. Its tech hubs, thriving industries, and diverse communities have transformed it into India\'s Silicon Valley. But with growth comes the challenge of congestion. Every day, thousands of vehicles crowd the Outer Ring Road and arterial routes, slowing movement, affecting productivity, and straining city life.',
      description2: 'Bengaluru Business Corridor (BBC) is the solution. Anchored by the Peripheral Ring Road (PRR), this project aims to create an 8-lane, access-controlled Urban Highway, complete with service roads, smart tolling, and future-ready provisions for Metro and mass transit systems.',
      highlight: 'With BBC, Bengaluru will have a transport backbone worthy of a global city.',
      cmStatement: [
        'Karnataka\'s growth must be inclusive and future-ready. Bengaluru, India\'s innovation hub, is set to enter its next phase through the Bengaluru Business Corridor. More than an infrastructure project, it is a vision for decongestion, balanced development, and sustainability.',
        'By connecting the city\'s periphery with world-class facilities, we are unlocking new opportunities, creating jobs, attracting global investment, and improving quality of life. Together, we are building a globally competitive, humane, and liveable Bengaluru.'
      ],
      cmName: '— Sri Siddaramaiah, Hon\'ble Chief Minister',
      dcmStatement: [
        'Bengaluru has always been a city of innovation and dreams. As Minister for Bengaluru Development and Town Planning, I see the Bengaluru Business Corridor as a transformative initiative that will redefine the city\'s growth. With the Peripheral Ring Road and integrated infrastructure, we aim to reduce congestion, unlock new economic zones, and ensure balanced development.',
        'More than roads, this project promises better opportunities, cleaner surroundings, and improved quality of life. I urge every Bengalurean to make this their own project, shaping a city we can proudly hand over to future generations.'
      ],
      dcmName: '— Sri DK Shivakumar, Hon\'ble Chief Minister',
      mlaStatement: [
        'Bengaluru\'s future depends on planned, inclusive, and people-centric development. As a representative of the people, I see the Bengaluru Business Corridor as a crucial initiative that will ease congestion, promote balanced growth, and bring development closer to our neighbourhoods.',
        'By strengthening connectivity and creating new economic opportunities, the Corridor will benefit local communities, small businesses, and the youth of our city. I am confident that this project will enhance everyday life for Bengalureans and contribute to a more equitable and sustainable Bengaluru.'
      ],
      mlaName: '— Sri N.A. Haris, Hon\'ble MLA',
      chairmanStatement: [
        'It is an honour to lead Bengaluru Business Corridor Ltd. at this transformative moment for our city. More than an infrastructure project, the Corridor is the foundation of a new urban ecosystem where commerce, community, and sustainability thrive together.',
        'Integrating global best practices with local priorities, the project will deliver world-class roads, green mobility, economic clusters, and liveable townships. As Chairman, I assure all stakeholders of our commitment to transparency, efficiency, and excellence. Together, we will make the Bengaluru Business Corridor a benchmark for urban development in India.'
      ],
      chairmanName: '— Sri L K Atheeq, IAS (Retd.)\nHon\'ble Chairman, BBC',
      headline: '',
      bodyCopy: '',
      quickFactsTitle: 'Quick Facts',
      quickFacts: [
        {
          heading: '73.04 km semicircular corridor across North & East Bengaluru',
          content: 'The Bengaluru Business Corridor is envisioned as a 73.04 km semi-circular corridor skirting the northern and eastern edges of the city',
          readMoreContent: 'designed to fundamentally alter the way traffic and economic movement flow across the metropolitan region. By providing a continuous high-capacity link between major radial corridors, the BBC enables long-distance and cross-city traffic to bypass the urban core, improving network efficiency while supporting Bengaluru\'s outward expansion in a planned manner.'
        },
        {
          heading: '100 m Right-of-Way with landscaped green buffers',
          content: 'Planned with a 100-metre Right-of-Way, BBC adopts a multi-layered design approach that goes beyond road infrastructure',
          readMoreContent: 'The RoW allows for the integration of transport, utilities, non-motorised movement, and environmental elements within a single corridor, creating a balanced urban edge. Landscaped green buffers and continuous open spaces within the RoW enhance environmental quality, reduce visual and noise impact, and establish the corridor as a sustainable urban interface rather than a mere highway.'
        },
        {
          heading: '10 major interchanges connecting National and State highways',
          content: 'As north–south and east–west traffic currently cuts through the city, strategically located grade-separated interchanges',
          readMoreContent: 'enable seamless directional movement across the corridor without entering the urban core. This significantly reduces congestion on existing arterial roads while improving regional connectivity.'
        },
        {
          heading: '5 Dedicated Railway Crossings (ROB/RUB) for seamless flow',
          content: 'To maintain seamless flow and improve safety, the corridor incorporates five dedicated Railway Crossings through Road Over Bridges (ROB) and Road Under Bridges (RUB).',
          readMoreContent: 'By fully separating road and rail movement, these crossings eliminate delays associated with level crossings and ensure uninterrupted corridor operations, particularly for freight and long-distance traffic, while maintaining compatibility with existing and future rail infrastructure.'
        },
        {
          heading: 'Investment of ₹26,786 crore that includes land acquisition.',
          content: 'The project entails an estimated investment of ₹26,786 crore, including land acquisition, reflecting its scale, engineering complexity, and long-term strategic importance.',
          readMoreContent: 'This investment supports not only construction but also planned land development, rehabilitation measures, and future-ready infrastructure systems. The financial commitment underscores the corridor\'s role as a foundational public asset designed to deliver sustained mobility, economic, and urban development benefits over multiple decades.'
        },
        {
          heading: 'Plotted commercial development along the corridor within the RoW, up to 34 km.',
          content: 'A key differentiator of the Bengaluru Business Corridor is the provision for plotted commercial development along nearly 34 km. of its length',
          readMoreContent: 'within the Right-of-Way. These planned commercial stretches are intended to anchor organised economic activity along the corridor, support employment generation, and enable value capture through structured land use. By integrating commercial development within the corridor framework, the project promotes orderly growth, discourages unplanned ribbon development, and positions the BBC as a transport-led economic growth corridor for the region.'
        }
      ]
    },

    // Quick Facts
    quickFacts: {
      title: 'Key Highlights',
      scope: 'Scope',
      scopeValue: '66.46 km semi-circular road connecting North and East Bengaluru',
      width: 'Width',
      widthValue: '100-metre wide road with beautiful green environment on both sides',
      connectivity: 'Connectivity',
      connectivityValue: '10 major interchanges linking national and state highways',
      smoothTravel: 'Smooth Travel',
      smoothTravelValue: '5 well-equipped railway crossings (ROB/RUB)',
      investment: 'Investment',
      investmentValue: 'Massive project worth ₹26,786 crore including land acquisition',
      commercial: 'Commercial Development',
      commercialValue: 'Special opportunity for commercial development along 34 km of the corridor'
    },

    // Project Section
    project: {
      title: 'The Project',
      subtitle: 'A Seamless Connection Around Bengaluru',
      description1: 'The BBC\'s PRR alignment has been prudently designed to connect every major arterial highway passing through Bengaluru. Beginning at Tumkur Road (NH-4, Madavara), the road arcs across the north and east before seamlessly joining Hosur Road (Konappana Agrahara) in the south.',
      keyInterchanges: 'Key Interchanges',
      keyPlan: 'BBC Blue Print',
      keyPlanDesc: 'View the Bengaluru Business Corridor (BBC) blue print to see the comprehensive infrastructure developments set to transform the city\'s mobility.',
      downloadKeyPlan: 'View BBC Blue Print (PDF)',
      prr1Button: 'Click here to view PRR-1 detailed alignment',
      prr1ButtonEnvironmentClearance: 'Click here to view the project\'s Environmental Clearance',
      sections: '3 Sections',
      sectionsLabel: 'For phased construction',
      interchanges: '10 Interchanges',
      interchangesLabel: 'At key highway junctions',
      robRub: '5 ROB/RUBs',
      robRubLabel: 'Railway crossings'
    },

    // Interchanges
    interchanges: {
      title: '11 Interchanges of PRR-1',
      subtitle: 'Key highway junctions along the corridor',
      description: 'Grade-separated interchanges and grade separators are being built at strategic locations along the BBC corridor.'
    },

    // Design & Safety
    design: {
      title: 'Design & Safety',
      subtitle: 'Future-Ready Design, Built for Every Journey',
      description: 'The BBC corridor is an integrated mobility platform. Designed with a 100-metre Right-of-Way, it accommodates a lot more than traffic.',
      features: {
        expressway: {
          heading: 'Eight-lane Expressway',
          content: 'With vehicle registrations in Bengaluru more than doubling over the past decade, the corridor is developed as a fully access-controlled eight-lane expressway',
          readMoreContent: 'designed to accommodate growing cross-city and regional traffic without burdening inner roads. IRC-compliant design standards ensure safe, consistent, and high-speed movement for long-distance and freight traffic.'
        },
        median: {
          heading: '4-metre Central Median',
          content: 'A 4-metre-wide central median is exclusively reserved for landscaping and greenery, serving both functional and ecological purposes.',
          readMoreContent: 'Apart from improving visual quality, the median acts as a glare barrier between opposing traffic streams and contributes to microclimate regulation along the corridor, reinforcing the project\'s emphasis on environmentally responsible infrastructure.'
        },
        serviceRoads: {
          heading: 'Service Roads',
          content: 'The corridor includes continuous service roads of 11 metres on the city-facing side and 7 metres on the outer side, designed to segregate local traffic',
          readMoreContent: 'from high-speed through movement. This arrangement allows safe access to adjacent developments, facilitates last-mile connectivity, and significantly reduces friction between local and expressway traffic, thereby enhancing overall operational efficiency.'
        },
        cycleTracks: {
          heading: 'Cycle Tracks',
          content: 'Dedicated 2-metre-wide cycle tracks are provided as part of the corridor cross-section to promote non-motorised transport.',
          readMoreContent: 'These tracks are physically separated from motorised traffic, offering cyclists a safe and uninterrupted route, and supporting broader goals of sustainable mobility and reduced dependency on private vehicles for short-distance travel.'
        },
        footpaths: {
          heading: 'Footpaths',
          content: 'A 3-metre-wide pedestrian footpath is incorporated to ensure comfortable and safe pedestrian movement along the corridor edge.',
          readMoreContent: 'Designed to IRC standards, these footpaths improve walkability, support local accessibility needs, and enhance overall road-user inclusivity, especially in areas with adjacent settlements or commercial activity.'
        },
        utilities: {
          heading: 'Utilities Built-In',
          content: 'The corridor design integrates dedicated underground utility ducts for electricity, telecom, water supply, optical fibre cables, and other services.',
          readMoreContent: 'This planned utility corridor minimizes future road cutting, simplifies maintenance and capacity augmentation, and ensures long-term adaptability as urban service demands evolve.'
        },
        solarLights: 'Solar Highway Street Lights',
        solarLightsDesc: 'Solar-powered street lights provide consistent illumination across the corridor, improving night-time safety while reducing reliance on grid power and long-term energy costs.',
        safety: {
          heading: 'Safety First',
          content: 'Comprehensive safety infrastructure is embedded throughout the corridor, including IRC-compliant crash barriers, hazard markers,',
          readMoreContent: 'reflective road furniture, and pedestrian guard rails at critical locations. These measures are intended to reduce accident severity, enhance visibility, and provide structured guidance to drivers and pedestrians under all operating conditions.'
        },
        signboards: {
          heading: 'Directional Signboards',
          content: 'The expressway is supported by a well-planned system of directional signboards with clear destination names and distance information,',
          readMoreContent: 'installed at identified decision points. These signages improve navigational clarity, reduce last-moment lane changes, and contribute to smoother traffic flow, especially for non-local and long-distance users.'
        }
      },
      footer: 'This combination of mobility, safety, and future-proofing makes the BBC corridor a landmark in road design for India.'
    },

    // Mobility & Tolling
    mobility: {
      title: 'Mobility & Tolling',
      subtitle: 'Smart Tolling, Hassle-Free Travel',
      description: 'No more long queues or cash-only booths. The BBC will use a closed tolling system, where commuters pay only for the distance they travel.',
      features: {
        etc: {
          heading: 'Electronic Toll Collection (ETC)',
          content: 'The corridor adopts a fully electronic tolling system, allowing vehicles fitted with On-Board Units (OBUs) to pass through toll plazas without stopping.',
          readMoreContent: 'This reduces queue formation, improves travel time reliability, lowers fuel consumption, and ensures uninterrupted high-speed movement along the expressway.'
        },
        touchGo: {
          heading: 'Touch-and-Go Cards',
          content: 'For frequent and local users, contactless smart card–based payments enable fast and convenient toll transactions.',
          readMoreContent: 'This system supports seamless daily commuting, minimizes cash handling, and enhances user convenience while integrating with digital payment ecosystems.'
        },
        manual: {
          heading: 'Manual Booths',
          content: 'A limited number of manual toll booths are retained as a contingency measure to accommodate non-ETC vehicles, system outages, or exceptional cases.',
          readMoreContent: 'This ensures operational flexibility and inclusivity without compromising overall toll plaza efficiency.'
        },
        tmc: {
          heading: 'Toll Management Centre (TMC)',
          content: 'All toll plazas are monitored through a centralized Toll Management Centre, equipped with real-time traffic, transaction, and surveillance systems.',
          readMoreContent: 'The TMC enables continuous performance monitoring, rapid incident response, revenue transparency, and data-driven decision-making to optimize corridor operations.'
        },
        mainlinePlazas: {
          heading: 'Mainline Plazas',
          content: 'Mainline toll plazas are positioned at both ends of the corridor and are integrated with the NICE Road network, enabling smooth and uninterrupted transitions for through traffic.',
          readMoreContent: 'This strategic placement supports end-to-end tolling, minimizes intermediate stoppages, and ensures efficient handling of long-distance and inter-city vehicle movement.'
        },
        entryExitPlazas: {
          heading: 'Entry / Exit Plazas',
          content: 'Dedicated entry and exit toll plazas at 8 major interchanges facilitate distance-based toll collection, ensuring users pay only for the section of the corridor they utilize.',
          readMoreContent: 'This system enhances fairness, supports flexible travel patterns, and improves user convenience while maintaining accurate traffic and revenue management.'
        }
      },
      footer: '<strong>The toll experience has been designed with speed and convenience in mind, ensuring minimal disruption to your journey.</strong>'
    },

    // ITS
    its: {
      title: 'Intelligent Transport Systems',
      subtitle: 'Technology That Moves With You',
      description: 'The Bengaluru Business Corridor is designed as a smart highway, where mobility is continuously monitored, managed, and optimized through advanced Intelligent Transport Systems (ITS).',
      descriptionReadMore: 'These systems enable real-time decision-making, faster incident response, and improved user experience, ensuring the corridor operates efficiently under varying traffic and weather conditions.',
      systems: {
        cctv: {
          heading: 'CCTV with Incident Detection',
          content: 'High-resolution CCTV cameras equipped with incident detection capabilities enable early',
          readMoreContent: 'identification of accidents, breakdowns, or abnormal traffic conditions, allowing swift response by enforcement and emergency teams.'
        },
        atcc: {
          heading: 'Automatic Traffic Counters (ATCC)',
          content: 'ATCC systems continuously record traffic volume, composition, and movement patterns, generating valuable data',
          readMoreContent: 'to support traffic planning, congestion management, and long-term corridor performance assessment.'
        },
        vvd: {
          heading: 'Video Vehicle Detectors (VVD)',
          content: 'Video-based vehicle detection systems replace conventional embedded road loops, offering accurate vehicle detection',
          readMoreContent: 'without intrusive road works, thereby reducing maintenance needs and improving system reliability.'
        },
        vms: {
          heading: 'Variable Message Signs (VMS)',
          content: 'Strategically placed VMS units provide real-time information on traffic conditions,',
          readMoreContent: 'weather alerts, incidents, and advisories, helping drivers make informed decisions before and during\u00A0their\u00A0journey.'
        },
        ofc: {
          heading: 'Optical Fiber Network',
          content: 'A dedicated optical fiber backbone connects all ITS components, toll plazas, and control centres,',
          readMoreContent: 'enabling high-speed data transmission, system integration, and centralized monitoring across the entire corridor.'
        }
      }
    },

    // Environment
    environment: {
      title: 'Environment & Land',
      subtitle: 'Built Responsibly, With Bengaluru\'s Future Environment in Mind',
      description: 'The Bengaluru Business Corridor is planned with a strong emphasis on environmental stewardship and social responsibility.',
      descriptionReadMore: 'The project requires approximately 2,557 acres of land, supported by comprehensive Environmental & Social Impact Assessments (ESIA) and Rehabilitation & Resettlement (R&R) studies, ensuring that development is balanced with ecological preservation and community welfare.',
      initiatives: {
        greenBuffers: {
          heading: 'Green Buffers',
          content: 'Continuous landscaped green buffers are developed along both edges of the corridor',
          readMoreContent: 'to serve as ecological shields, helping mitigate dust, noise, and heat while enhancing the overall environmental quality of the surrounding areas.'
        },
        lakeRejuvenation: {
          heading: 'Lake Rejuvenation',
          content: 'As part of environmental enhancement measures, seven existing lakes along the corridor are proposed for rejuvenation',
          readMoreContent: 'through desilting, strengthening of bunds, proper pitching, and the creation of walkways, improving water retention and local ecosystems.'
        },
        serviceAreas: {
          heading: 'Service Areas',
          content: 'Designated service areas are planned at strategic locations, offering fuel stations, rest zones, and basic amenities',
          readMoreContent: 'to support long-distance travelers and improve journey comfort without disrupting corridor operations.'
        },
        publicTransport: {
          heading: 'Public Transport Integration',
          content: 'Bus shelters are provided along service roads to enable seamless public transport connectivity,',
          readMoreContent: 'ensuring the corridor supports multimodal travel and remains accessible to nearby communities.'
        },
        sustainableLighting: {
          heading: 'Sustainable Lighting',
          content: 'The corridor adopts energy-efficient, solar-powered lighting systems, reducing carbon footprint',
          readMoreContent: 'while ensuring consistent illumination for safety and operational reliability.'
        },
        waterfront: {
          heading: 'Waterfront Development',
          content: 'Lakefront development is planned with careful controls to preserve existing water spread areas,',
          readMoreContent: 'ensuring that ecological balance is maintained while improving accessibility and aesthetic value around water bodies.'
        }
      },
      lakeSustainability: {
        heading: 'Lake Sustainability Initiative',
        content: 'The PRR passes along and close to 7 lakes across the full length of the urban highway. The capacity of these lakes will be increased by removing silt build-up, thus deepening the water depth.',
        readMoreContent: 'Lakes will be rejuvenated by providing proper pitching, walkways, and clear boundaries. Waterfront development will be initiated without any reduction in the water spread area of the lake.'
      },
      stats: {
        land: '2,557 Acres',
        landLabel: 'Total land requirement',
        lakes: '7 Lakes',
        lakesLabel: 'To be rejuvenated',
        green: '100% Green',
        greenLabel: 'Solar lighting throughout'
      }
    },

    // Delivery & Cost
    delivery: {
      title: 'Delivery & Cost',
      subtitle: 'An Investment in Bengaluru\'s Growth',
      description: 'The Bengaluru Business Corridor represents one of the largest infrastructure investments undertaken in Karnataka, reflecting the scale, complexity, and long-term economic significance of the project. The investment framework balances construction, land procurement, social safeguards, and environmental responsibilities to ensure sustainable delivery.',
      totalInvestment: {
        heading: 'Total Investment',
        content: 'Approximately ₹27,000 crore',
        contentFull: 'The project entails an estimated investment of approximately ₹27,000 crore,',
        readMoreContent: 'positioning it among the most significant transport infrastructure initiatives in the state\'s history.'
      },
      costItems: {
        civilWorks: {
          heading: 'Civil Works',
          content: 'An allocation of ₹7,000–8,000 crore is earmarked for civil works, covering expressway construction, structures, service roads, interchanges, bridges, and associated corridor infrastructure.',
          contentFull: 'An allocation of ₹7,000–8,000 crore is earmarked for civil works, covering expressway construction, structures, service roads, interchanges, bridges, and associated corridor infrastructure.',
          readMoreContent: null
        },
        landAcquisition: {
          heading: 'Land Acquisition',
          content: 'A substantial ₹20,511 crore is dedicated to land acquisition, reflecting the corridor\'s scale and the commitment to acquiring land in a planned and lawful manner.',
          contentFull: 'A substantial ₹20,511 crore is dedicated to land acquisition, reflecting the corridor\'s scale and the commitment to acquiring land in a planned and lawful manner.',
          readMoreContent: null
        },
        rnr: {
          heading: 'Rehabilitation & Resettlement',
          content: 'An estimated ₹750 crore is provisioned for Rehabilitation and Resettlement (R&R), ensuring fair compensation, structured relocation, and livelihood support for affected communities.',
          contentFull: 'An estimated ₹750 crore is provisioned for Rehabilitation and Resettlement (R&R), ensuring fair compensation, structured relocation, and livelihood support for affected communities.',
          readMoreContent: null
        },
        environmental: {
          heading: 'Environmental Measures',
          content: 'Around ₹65 crore is allocated for environmental mitigation measures, including ecological safeguards, restoration activities, and compliance with statutory environmental requirements.',
          contentFull: 'Around ₹65 crore is allocated for environmental mitigation measures, including ecological safeguards, restoration activities, and compliance with statutory environmental requirements.',
          readMoreContent: null
        }
      },
      constructionTimeline: {
        heading: 'Construction Timeline',
        content: '30–36 months for civil works',
        contentFull: 'The corridor is planned to be delivered in three distinct sections, allowing phased execution and better project management.',
        readMoreContent: 'Civil works are expected to be completed within 30–36 months from commencement.'
      },
      smartSystems: {
        heading: 'Smart Systems Rollout',
        content: '18 months phased implementation',
        contentFull: 'Deployment of Intelligent Transport Systems (ITS) will follow a phased implementation strategy,',
        readMoreContent: 'enabling smooth integration with corridor operations. Full ITS rollout is planned within 18 months, ensuring the corridor functions as a smart, technology-enabled highway.'
      },
      message: '<strong>This is not just an investment in roads—it is an investment for a stronger economy, faster commutes, better environment & safer travel for Bengaluru.</strong>',
      note: '* Estimated costs have the potential to be revised as per actuals during project execution'
    },

    // Contact Us Section
    contactUs: {
      title: 'Contact Us',
      chairmen: {
        haris: {
          name: 'Sri N. A. HARIS',
          designation: 'Chairman, BDA'
        },
        atheeq: {
          name: 'Sri L K Atheeq, IAS (Retd.)',
          designation: 'Chairman, BBC'
        },
        manivannan: {
          name: 'Sri Major Manivannan P., IAS',
          designation: 'Commissioner, BDA'
        }
      },
      tableHeaders: {
        slNo: 'Sl. No.',
        name: 'Name',
        designation: 'Designation',
        contact: 'Contact'
      },
      contacts: [
        {
          name: 'Jagadish KH, K.A.S',
          designation: 'Deputy Commissioner (Additional Land Acquisition)',
          contact: '+91 8050545425'
        },
        {
          name: 'Shruthi M K, KAS',
          designation: 'Special Land Acquisition Officer BBC-1',
          contact: '+91 9591056238'
        },
        {
          name: 'Pallavi Satenahalli, KAS',
          designation: 'Special Land Acquisition Officer BBC-2',
          contact: '+91 7019667299'
        },
        {
          name: 'Nikitha M Chinnaswamy, KAS',
          designation: 'Special Land Acquisition Officer BBC-3',
          contact: '+91 9742164846'
        },
        {
          name: 'Kantharaju K J, KAS',
          designation: 'Special Land Acquisition Officer BBC-4',
          contact: '+91 9611002697'
        },
        {
          name: 'Manjunath Dombar, KAS',
          designation: 'Special Land Acquisition Officer BBC-5',
          contact: '+91 9880297387'
        },
        {
          name: 'Mukundaswamy R G, KAS',
          designation: 'Special Land Acquisition Officer BBC-6',
          contact: '+91 7899507369'
        },
        {
          name: 'Preetham Nasalapure, KAS',
          designation: 'Special Land Acquisition Officer BBC-7',
          contact: '+91 8762701033'
        },
        {
          name: 'Kunal.K, KAS',
          designation: 'Special Land Acquisition Officer BBC-8',
          contact: '+91 8095232489'
        },
        {
          name: 'Jambagi Renukaprasad Deelip, KAS',
          designation: 'Special Land Acquisition Officer BBC-9',
          contact: '+91 9606536325'
        }
      ]
    },

  }
};

